
// ChatGPT prompts

/*

// file letters
i would like a json array with the english letters a through h as element "en" and their spanish names as the element "es", french as "fr", german as "de", the italian as "it", the portuguese as "pt"

// array of words into 5 languages
This is a json array of English words. Please translate them into collequial language for use in a chess app. The result should be a new json array with each array entry being an object where the English word is the "en" element and the Spanish word is the "es” element, French in the "fr" element, German in the "de" element, Italian in the "it" element and Portuguese in the "pt"

*/

/*

{ "en": "a", "es": "a", "fr": "a", "de": "a", "it": "a", "pt": "a" },
  { "en": "b", "es": "be", "fr": "bé", "de": "be", "it": "bi", "pt": "bê" },
  { "en": "c", "es": "ce", "fr": "cé", "de": "ze", "it": "ci", "pt": "cê" },
  { "en": "d", "es": "de", "fr": "dé", "de": "de", "it": "di", "pt": "dê" },
  { "en": "e", "es": "e", "fr": "e", "de": "e", "it": "e", "pt": "ê" },
  { "en": "f", "es": "efe", "fr": "effe", "de": "ef", "it": "effe", "pt": "efe" },
  { "en": "g", "es": "ge", "fr": "gé", "de": "ge", "it": "gi", "pt": "gê" },
  { "en": "h", "es": "hache", "fr": "hache", "de": "ha", "it": "acca", "pt": "agá" }
*/

const completeWordlist = [
 "a",
 "abort",
 "accept",
 "account",
 "address",
 "alfa",
 "and",
 "anna",
 "annual",
 "arena",
 "as",
 "at",
 "back",
 "b",
 "bella",
 "bishop",
 "black",
 "blind",
 "blindfold",
 "blindness",
 "board",
 "bravo",
 "cancel",
 "capture",
 "captures",
 "castle",
 "cesar",
 "challenge",
 "charlie",
 "chess",
 "color",
 "colors",
 "command",
 "computer",
 "confirm",
 "connect",
 "contact",
 "continue",
 "control",
 "coordinate",
 "coordinates",
 "correspondence",
 "d",
 "david",
 "day",
 "days",
 "delta",
 "describe",
 "difficulty",
 "disc",
 "disconnect",
 "discs",
 "done",
 "down",
 "draw",
 "e",
 "echo",
 "eight",
 "eighteen",
 "eighty",
 "eleven",
 "email",
 "empty",
 "end",
 "engine",
 "engines",
 "english",
 "eva",
 "explain",
 "f",
 "felix",
 "fifteen",
 "fifty",
 "file",
 "five",
 "for",
 "forty",
 "four",
 "fourteen",
 "fox",
 "foxtrot",
 "french",
 "g",
 "game",
 "games",
 "general",
 "german",
 "go",
 "golf",
 "gustav",
 "h",
 "hector",
 "history",
 "hotel",
 "ignore",
 "in",
 "increment",
 "inside",
 "italian",
 "join",
 "keyword",
 "king",
 "knight",
 "landing",
 "language",
 "languages",
 "last",
 "leave",
 "lee",
 "letters",
 "line",
 "listen",
 "locate",
 "log",
 "long",
 "maximum",
 "minutes",
 "month",
 "monthly",
 "move",
 "moves",
 "mute",
 "my",
 "names",
 "new",
 "next",
 "nine",
 "nineteen",
 "ninety",
 "no",
 "none",
 "off",
 "offer",
 "offered",
 "on",
 "one",
 "open",
 "opponent",
 "option",
 "options",
 "outside",
 "pawn",
 "perpetual",
 "piece",
 "pieces",
 "play",
 "player",
 "portuguese",
 "practice",
 "previous",
 "queen",
 "random",
 "rank",
 "rapid",
 "rated",
 "recognizer",
 "refresh",
 "register",
 "regular",
 "remember",
 "repeat",
 "replay",
 "resign",
 "reveal",
 "revert",
 "review",
 "robot",
 "rook",
 "scroll",
 "sec",
 "second",
 "c",
 "set",
 "seven",
 "seventeen",
 "seventy",
 "short",
 "show",
 "side",
 "sign",
 "six",
 "sixteen",
 "sixty",
 "skill",
 "spanish",
 "speaking",
 "speech",
 "square",
 "start",
 "strength",
 "subscribe",
 "subscriber",
 "system",
 "take",
 "takes",
 "ten",
 "terms",
 "thirteen",
 "thirty",
 "three",
 "time",
 "tournament",
 "translated",
 "twelve",
 "twenty",
 "two",
 "up",
 "update",
 "verify",
 "voice",
 "voices",
 "white",
 "words",
 "yes",
 "you",
 "zero"
] 

const rawJson = [
    {
        "en": "blindfold",
        "es": "ciegas",
        "fr": "aveugle",
        "de": "blind",
        "it": "bendato",
        "pt": "venda"
    },
    {
        "en": "command",
        "es": "comando",
        "fr": "commande",
        "de": "befehl",
        "it": "comando",
        "pt": "comando"
    },
    {
        "en": "computer",
        "es": "computadora",
        "fr": "ordinateur",
        "de": "Computer",
        "it": "computer",
        "pt": "computador"
    },
    {
        "en": "continue",
        "es": "continuar",
        "fr": "continuer",
        "de": "weiter",
        "it": "continua",
        "pt": "continuar"
    },
    {
        "en": "done",
        "es": "hecho",
        "fr": "terminé",
        "de": "fertig",
        "it": "fatto",
        "pt": "concluído"
    },
    {
        "en": "down",
        "es": "abajo",
        "fr": "bas",
        "de": "unten",
        "it": "giù",
        "pt": "baixo"
    },
    {
        "en": "end",
        "es": "fin",
        "fr": "fin",
        "de": "Ende",
        "it": "fine",
        "pt": "fim"
    },
    {
        "en": "game",
        "es": "partida",
        "fr": "partie",
        "de": "Spiel",
        "it": "partita",
        "pt": "jogo"
    },
    {
        "en": "history",
        "es": "historial",
        "fr": "historique",
        "de": "Verlauf",
        "it": "cronologia",
        "pt": "histórico"
    },
    {
        "en": "in",
        "es": "en",
        "fr": "dans",
        "de": "in",
        "it": "in",
        "pt": "em"
    },
    {
        "en": "log",
        "es": "registro",
        "fr": "journal",
        "de": "Protokoll",
        "it": "registro",
        "pt": "registro"
    },
    {
        "en": "scroll",
        "es": "desplazar",
        "fr": "faire défiler",
        "de": "scrollen",
        "it": "scorri",
        "pt": "rolar"
    },
    {
        "en": "up",
        "es": "arriba",
        "fr": "haut",
        "de": "oben",
        "it": "su",
        "pt": "cima"
    },
    {
        "en": "sign",
        "es": "firma",
        "fr": "signature",
        "de": "Anmelden",
        "it": "accedi",
        "pt": "entrar"
    },
    {
        "en": "previous",
        "es": "anterior",
        "fr": "précédent",
        "de": "vorherig",
        "it": "precedente",
        "pt": "anterior"
    },
    {
        "en": "register",
        "es": "registrarse",
        "fr": "registre",
        "de": "registrieren",
        "it": "registrati",
        "pt": "cadastrar"
    },
    {
        "en": "my",
        "es": "mi",
        "fr": "mon",
        "de": "mein",
        "it": "mio",
        "pt": "meu"
    },
    {
        "en": "account",
        "es": "cuenta",
        "fr": "compte",
        "de": "Konto",
        "it": "account",
        "pt": "conta"
    },
    {
        "en": "options",
        "es": "opciones",
        "fr": "options",
        "de": "Optionen",
        "it": "opzioni",
        "pt": "opções"
    },
    {
        "en": "replay",
        "es": "repetición",
        "fr": "rejouer",
        "de": "wiedergeben",
        "it": "ripeti",
        "pt": "repetir"
    },
    {
        "en": "reveal",
        "es": "revelar",
        "fr": "révéler",
        "de": "zeigen",
        "it": "mostra",
        "pt": "revelar"
    },
    {
        "en": "revert",
        "es": "revertir",
        "fr": "revenir",
        "de": "verbergen",
        "it": "ripristina",
        "pt": "reverter"
    },
    {
        "en": "review",
        "es": "revisión",
        "fr": "révision",
        "de": "überprüfen",
        "it": "revisiona",
        "pt": "revisar"
    },
    {
        "en": "start",
        "es": "iniciar",
        "fr": "commencer",
        "de": "starten",
        "it": "inizia",
        "pt": "iniciar"
    },
    {
        "en": "subscribe",
        "es": "suscribirse",
        "fr": "s'abonner",
        "de": "abonnieren",
        "it": "iscriviti",
        "pt": "assinar"
    },
    {
        "en": "subscriber",
        "es": "suscriptor",
        "fr": "abonné",
        "de": "Abonnent",
        "it": "iscritto",
        "pt": "assinante"
    },
    {
        "en": "takeback",
        "es": "retirar jugada",
        "fr": "reprendre",
        "de": "Rücknahme",
        "it": "annulla",
        "pt": "desfazer"
    },
    {
        "en": "explain",
        "es": "explicar",
        "fr": "expliquer",
        "de": "erklären",
        "it": "spiega",
        "pt": "explicar"
    },
    {
        "en": "play",
        "es": "jugar",
        "fr": "jouer",
        "de": "spielen",
        "it": "gioca",
        "pt": "jogar"
    },
    {
        "en": "lee",
        "es": "lee",
        "fr": "lee",
        "de": "lee",
        "it": "lee",
        "pt": "lee"
    },
    {
        "en": "chess",
        "es": "ajedrez",
        "fr": "échecs",
        "de": "Schach",
        "it": "scacchi",
        "pt": "xadrez"
    },
    {
        "en": "engine",
        "es": "motor",
        "fr": "moteur",
        "de": "Engine",
        "it": "motore",
        "pt": "motor"
    },
    {
        "en": "engines",
        "es": "máquina",
        "fr": "moteurs",
        "de": "Engines",
        "it": "motori",
        "pt": "motores"
    },
    {
        "en": "ignore",
        "es": "ignorar",
        "fr": "ignorer",
        "de": "ignorieren",
        "it": "ignora",
        "pt": "ignorar"
    },
    {
        "en": "mute",
        "es": "silenciar",
        "fr": "muet",
        "de": "stumm",
        "it": "muto",
        "pt": "silenciar"
    },
    {
        "en": "listen",
        "es": "escuchar",
        "fr": "écouter",
        "de": "zuhören",
        "it": "ascolta",
        "pt": "ouvir"
    },
    {
        "en": "show",
        "es": "mostrar",
        "fr": "afficher",
        "de": "anzeigen",
        "it": "mostra",
        "pt": "mostrar"
    },
    {
        "en": "landing",
        "es": "inicio",
        "fr": "accueil",
        "de": "Startseite",
        "it": "pagina iniziale",
        "pt": "inicial"
    },
    {
        "en": "on",
        "es": "en",
        "fr": "activé",
        "de": "ein",
        "it": "acceso",
        "pt": "ligado"
    },
    {
        "en": "line",
        "es": "línea",
        "fr": "ligne",
        "de": "Linie",
        "it": "linea",
        "pt": "linha"
    },
    {
        "en": "lichess",
        "es": "lichess",
        "fr": "lichess",
        "de": "lichess",
        "it": "lichess",
        "pt": "lichess"
    },
    {
        "en": "verbal",
        "es": "verbal",
        "fr": "verbal",
        "de": "verbal",
        "it": "verbale",
        "pt": "verbal"
    },
    {
        "en": "signin",
        "es": "iniciar sesión",
        "fr": "connexion",
        "de": "Anmelden",
        "it": "accedi",
        "pt": "entrar"
    },
    {
        "en": "preferences",
        "es": "preferencias",
        "fr": "préférences",
        "de": "Einstellungen",
        "it": "preferenze",
        "pt": "preferências"
    },
    {
        "en": "support",
        "es": "soporte",
        "fr": "support",
        "de": "Support",
        "it": "supporto",
        "pt": "suporte"
    },
    {
        "en": "page",
        "es": "página",
        "fr": "page",
        "de": "Seite",
        "it": "pagina",
        "pt": "página"
    },
    {
        "en": "new",
        "es": "nuevo",
        "fr": "nouveau",
        "de": "neu",
        "it": "nuovo",
        "pt": "novo"
    },
    {
        "en": "info",
        "es": "informacién",
        "fr": "info",
        "de": "Info",
        "it": "info",
        "pt": "informações"
    },
    {
        "en": "option",
        "es": "opción",
        "fr": "option",
        "de": "Option",
        "it": "opzione",
        "pt": "opção"
    },
    {
        "en": "take",
        "es": "tomar",
        "fr": "prendre",
        "de": "nehmen",
        "it": "prendi",
        "pt": "pegar"
    },
    {
        "en": "back",
        "es": "atrás",
        "fr": "retour",
        "de": "zurück",
        "it": "indietro",
        "pt": "voltar"
    },
    {
        "en": "repeat",
        "es": "repetir",
        "fr": "répéter",
        "de": "wiederholen",
        "it": "ripeti",
        "pt": "repetir"
    },
    {
        "en": "describe",
        "es": "describir",
        "fr": "décrire",
        "de": "beschreiben",
        "it": "descrivi",
        "pt": "descrever"
    },
    {
        "en": "at",
        "es": "en",
        "fr": "à",
        "de": "bei",
        "it": "a",
        "pt": "em"
    },
    {
        "en": "move",
        "es": "movimiento",
        "fr": "coup",
        "de": "Zug",
        "it": "mossa",
        "pt": "mover"
    },
    {
        "en": "takes",
        "es": "por toma captura",
        "fr": "capture",
        "de": "nimmt",
        "it": "prende",
        "pt": "toma"
    },
    {
        "en": "capture",
        "es": "capturar",
        "fr": "capturer",
        "de": "schlagen",
        "it": "cattura",
        "pt": "capturar"
    },
    {
        "en": "captures",
        "es": "captura",
        "fr": "captures",
        "de": "schlägt",
        "it": "catture",
        "pt": "captura"
    },
    {
        "en": "castle",
        "es": "enroque",
        "fr": "roque",
        "de": "rochade",
        "it": "arrocco",
        "pt": "roque"
    },
    {
        "en": "side",
        "es": "lado",
        "fr": "côté",
        "de": "Seite",
        "it": "lato",
        "pt": "lado"
    },
    {
        "en": "short",
        "es": "corto",
        "fr": "court",
        "de": "kurz",
        "it": "corto",
        "pt": "curto"
    },
    {
        "en": "long",
        "es": "largo",
        "fr": "long",
        "de": "lang",
        "it": "lungo",
        "pt": "longo"
    },
    {
        "en": "rook",
        "es": "torre",
        "fr": "tour",
        "de": "Turm",
        "it": "torre",
        "pt": "torre"
    },
    {
        "en": "bishop",
        "es": "alfil",
        "fr": "fou",
        "de": "Läufer",
        "it": "alfiere",
        "pt": "bispo"
    },
    {
        "en": "knight",
        "es": "caballo",
        "fr": "cavalier",
        "de": "Springer",
        "it": "cavallo",
        "pt": "cavalo"
    },
    {
        "en": "king",
        "es": "rey",
        "fr": "roi",
        "de": "König",
        "it": "re",
        "pt": "rei"
    },
    {
        "en": "queen",
        "es": "dama reina",
        "fr": "dame",
        "de": "Dame",
        "it": "donna",
        "pt": "rainha"
    },
    {
        "en": "pawn",
        "es": "peón",
        "fr": "pion",
        "de": "Bauer",
        "it": "pedone",
        "pt": "peão"
    },
    {
        "en": "alfa",
        "es": "alfa",
        "fr": "alfa",
        "de": "alfa",
        "it": "alfa",
        "pt": "alfa"
    },
    {
        "en": "bravo",
        "es": "bravo",
        "fr": "bravo",
        "de": "bravo",
        "it": "bravo",
        "pt": "bravo"
    },
    {
        "en": "charlie",
        "es": "charlie",
        "fr": "charlie",
        "de": "charlie",
        "it": "charlie",
        "pt": "charlie"
    },
    {
        "en": "delta",
        "es": "delta",
        "fr": "delta",
        "de": "delta",
        "it": "delta",
        "pt": "delta"
    },
    {
        "en": "echo",
        "es": "eco",
        "fr": "écho",
        "de": "echo",
        "it": "echo",
        "pt": "eco"
    },
    {
        "en": "fox",
        "es": "fox",
        "fr": "fox",
        "de": "fuchs",
        "it": "fox",
        "pt": "raposa"
    },
    {
        "en": "foxtrot",
        "es": "foca",
        "fr": "foxtrot",
        "de": "foxtrott",
        "it": "foxtrot",
        "pt": "foxtrot"
    },
    {
        "en": "golf",
        "es": "golf",
        "fr": "golf",
        "de": "golf",
        "it": "golf",
        "pt": "golf"
    },
    {
        "en": "hotel",
        "es": "hotel",
        "fr": "hôtel",
        "de": "hotel",
        "it": "hotel",
        "pt": "hotel"
    },
    {
        "en": "anna",
        "es": "ana",
        "fr": "anna",
        "de": "anna",
        "it": "anna",
        "pt": "anna"
    },
    {
        "en": "bella",
        "es": "bella",
        "fr": "bella",
        "de": "bella",
        "it": "bella",
        "pt": "bella"
    },
    {
        "en": "cesar",
        "es": "césar",
        "fr": "césar",
        "de": "cesar",
        "it": "cesar",
        "pt": "césar"
    },
    {
        "en": "david",
        "es": "david",
        "fr": "david",
        "de": "david",
        "it": "david",
        "pt": "david"
    },
    {
        "en": "eva",
        "es": "eva",
        "fr": "eva",
        "de": "eva",
        "it": "eva",
        "pt": "eva"
    },
    {
        "en": "felix",
        "es": "félix",
        "fr": "félix",
        "de": "felix",
        "it": "felix",
        "pt": "félix"
    },
    {
        "en": "gustav",
        "es": "gustavo",
        "fr": "gustave",
        "de": "gustav",
        "it": "gustav",
        "pt": "gustav"
    },
    {
        "en": "hector",
        "es": "héctor",
        "fr": "hector",
        "de": "hector",
        "it": "hector",
        "pt": "hector"
    },
    {
        "en": "zero",
        "es": "cero",
        "fr": "zéro",
        "de": "null",
        "it": "zero",
        "pt": "zero"
    },
    {
        "en": "one",
        "es": "uno",
        "fr": "un",
        "de": "eins",
        "it": "uno",
        "pt": "um"
    },
    {
        "en": "two",
        "es": "dos",
        "fr": "deux",
        "de": "zwei",
        "it": "due",
        "pt": "dois"
    },
    {
        "en": "three",
        "es": "tres",
        "fr": "trois",
        "de": "drei",
        "it": "tre",
        "pt": "três"
    },
    {
        "en": "four",
        "es": "cuatro",
        "fr": "quatre",
        "de": "vier",
        "it": "quattro",
        "pt": "quatro"
    },
    {
        "en": "five",
        "es": "cinco",
        "fr": "cinq",
        "de": "fünf",
        "it": "cinque",
        "pt": "cinco"
    },
    {
        "en": "six",
        "es": "seis",
        "fr": "six",
        "de": "sechs",
        "it": "sei",
        "pt": "seis"
    },
    {
        "en": "seven",
        "es": "siete",
        "fr": "sept",
        "de": "sieben",
        "it": "sette",
        "pt": "sete"
    },
    {
        "en": "eight",
        "es": "ocho",
        "fr": "huit",
        "de": "acht",
        "it": "otto",
        "pt": "oito"
    },
    {
        "en": "black",
        "es": "negras",
        "fr": "noir",
        "de": "schwarz",
        "it": "nero",
        "pt": "preto"
    },
    {
        "en": "white",
        "es": "blancas",
        "fr": "blanc",
        "de": "weiß",
        "it": "bianco",
        "pt": "branco"
    },
    {
        "en": "rank",
        "es": "fila",
        "fr": "rang",
        "de": "Reihe",
        "it": "riga",
        "pt": "fileira"
    },
    {
        "en": "file",
        "es": "columna",
        "fr": "colonne",
        "de": "Spalte",
        "it": "colonna",
        "pt": "coluna"
    },
    {
        "en": "square",
        "es": "casilla",
        "fr": "case",
        "de": "Feld",
        "it": "casella",
        "pt": "casa"
    },
    {
        "en": "locate",
        "es": "localizar",
        "fr": "localiser",
        "de": "finden",
        "it": "localizza",
        "pt": "localizar"
    },
    {
        "en": "empty",
        "es": "vacía",
        "fr": "vide",
        "de": "leer",
        "it": "vuoto",
        "pt": "vazio"
    },
    {
        "en": "next",
        "es": "siguiente",
        "fr": "suivant",
        "de": "nächste",
        "it": "successivo",
        "pt": "próximo"
    },
    {
        "en": "general",
        "es": "general",
        "fr": "général",
        "de": "allgemein",
        "it": "generale",
        "pt": "geral"
    },
    {
        "en": "blindness",
        "es": "ceguera",
        "fr": "cécité",
        "de": "Blindheit",
        "it": "cecità",
        "pt": "cegueira"
    },
    {
        "en": "difficulty",
        "es": "dificultad",
        "fr": "difficulté",
        "de": "Schwierigkeit",
        "it": "difficoltà",
        "pt": "dificuldade"
    },
    {
        "en": "blind",
        "es": "ciego",
        "fr": "aveugle",
        "de": "blind",
        "it": "cieco",
        "pt": "cego"
    },
    {
        "en": "for",
        "es": "para",
        "fr": "pour",
        "de": "für",
        "it": "per",
        "pt": "para"
    },
    {
        "en": "opponent",
        "es": "oponente",
        "fr": "adversaire",
        "de": "Gegner",
        "it": "avversario",
        "pt": "oponente"
    },
    {
        "en": "moves",
        "es": "movimientos",
        "fr": "coups",
        "de": "Züge",
        "it": "mosse",
        "pt": "lances"
    },
    {
        "en": "strength",
        "es": "fuerza",
        "fr": "force",
        "de": "Stärke",
        "it": "forza",
        "pt": "força"
    },
    {
        "en": "skill",
        "es": "habilidad",
        "fr": "compétence",
        "de": "level",
        "it": "abilità",
        "pt": "habilidade"
    },
    {
        "en": "color",
        "es": "color",
        "fr": "couleur",
        "de": "Farbe",
        "it": "colore",
        "pt": "cor"
    },
    {
        "en": "you",
        "es": "tú",
        "fr": "vous",
        "de": "du",
        "it": "tu",
        "pt": "você"
    },
    {
        "en": "keyword",
        "es": "palabra clave",
        "fr": "mot-clé",
        "de": "Schlüsselwort",
        "it": "parola chiave",
        "pt": "palavra chave"
    },
    {
        "en": "key",
        "es": "clave",
        "fr": "clé",
        "de": "Schlüssel",
        "it": "chiave",
        "pt": "chave"
    },
    {
        "en": "word",
        "es": "palabra",
        "fr": "mot",
        "de": "Wort",
        "it": "parola",
        "pt": "palavra"
    },
    {
        "en": "required",
        "es": "requerido",
        "fr": "requis",
        "de": "erforderlich",
        "it": "necessario",
        "pt": "obrigatório"
    },
    {
        "en": "first",
        "es": "primero",
        "fr": "premier",
        "de": "erste",
        "it": "primo",
        "pt": "primeiro"
    },
    {
        "en": "begin",
        "es": "comenzar",
        "fr": "commencer",
        "de": "beginnen",
        "it": "inizia",
        "pt": "começar"
    },
    {
        "en": "last",
        "es": "último",
        "fr": "dernier",
        "de": "letzte",
        "it": "ultimo",
        "pt": "último"
    },
    {
        "en": "nine",
        "es": "nueve",
        "fr": "neuf",
        "de": "neun",
        "it": "nove",
        "pt": "nove"
    },
    {
        "en": "ten",
        "es": "diez",
        "fr": "dix",
        "de": "zehn",
        "it": "dieci",
        "pt": "dez"
    },
    {
        "en": "eleven",
        "es": "once",
        "fr": "onze",
        "de": "elf",
        "it": "undici",
        "pt": "onze"
    },
    {
        "en": "twelve",
        "es": "doce",
        "fr": "douze",
        "de": "zwölf",
        "it": "dodici",
        "pt": "doze"
    },
    {
        "en": "thirteen",
        "es": "trece",
        "fr": "treize",
        "de": "dreizehn",
        "it": "tredici",
        "pt": "treze"
    },
    {
        "en": "fourteen",
        "es": "catorce",
        "fr": "quatorze",
        "de": "vierzehn",
        "it": "quattordici",
        "pt": "quatorze"
    },
    {
        "en": "fifteen",
        "es": "quince",
        "fr": "quinze",
        "de": "fünfzehn",
        "it": "quindici",
        "pt": "quinze"
    },
    {
        "en": "sixteen",
        "es": "dieciséis",
        "fr": "seize",
        "de": "sechzehn",
        "it": "sedici",
        "pt": "dezesseis"
    },
    {
        "en": "seventeen",
        "es": "diecisiete",
        "fr": "dix-sept",
        "de": "siebzehn",
        "it": "diciassette",
        "pt": "dezessete"
    },
    {
        "en": "eighteen",
        "es": "dieciocho",
        "fr": "dix-huit",
        "de": "achtzehn",
        "it": "diciotto",
        "pt": "dezoito"
    },
    {
        "en": "nineteen",
        "es": "diecinueve",
        "fr": "dix-neuf",
        "de": "neunzehn",
        "it": "diciannove",
        "pt": "dezenove"
    },
    {
        "en": "twenty",
        "es": "veinte",
        "fr": "vingt",
        "de": "zwanzig",
        "it": "venti",
        "pt": "vinte"
    },
    {
        "en": "thirty",
        "es": "treinta",
        "fr": "trente",
        "de": "dreißig",
        "it": "trenta",
        "pt": "trinta"
    },
    {
        "en": "forty",
        "es": "cuarenta",
        "fr": "quarante",
        "de": "vierzig",
        "it": "quaranta",
        "pt": "quarenta"
    },
    {
        "en": "fifty",
        "es": "cincuenta",
        "fr": "cinquante",
        "de": "fünfzig",
        "it": "cinquanta",
        "pt": "cinquenta"
    },
    {
        "en": "sixty",
        "es": "sesenta",
        "fr": "soixante",
        "de": "sechzig",
        "it": "sessanta",
        "pt": "sessenta"
    },
    {
        "en": "seventy",
        "es": "setenta",
        "fr": "soixante-dix",
        "de": "siebzig",
        "it": "settanta",
        "pt": "setenta"
    },
    {
        "en": "eighty",
        "es": "ochenta",
        "fr": "quatre-vingts",
        "de": "achtzig",
        "it": "ottanta",
        "pt": "oitenta"
    },
    {
        "en": "ninety",
        "es": "noventa",
        "fr": "quatre-vingt-dix",
        "de": "neunzig",
        "it": "novanta",
        "pt": "noventa"
    },
    {
        "en": "komodo",
        "es": "komodo",
        "fr": "komodo",
        "de": "komodo",
        "it": "komodo",
        "pt": "komodo"
    },
    {
        "en": "komo",
        "es": "komo",
        "fr": "komo",
        "de": "komo",
        "it": "komo",
        "pt": "komo"
    },
    {
        "en": "sfish",
        "es": "sfish",
        "fr": "sfish",
        "de": "sfish",
        "it": "sfish",
        "pt": "sfish"
    },
    {
        "en": "stockfish",
        "es": "stockfish",
        "fr": "stockfish",
        "de": "stockfish",
        "it": "stockfish",
        "pt": "stockfish"
    },
    {
        "en": "as",
        "es": "como",
        "fr": "comme",
        "de": "so",
        "it": "come",
        "pt": "como"
    },
    {
        "en": "best",
        "es": "mejor",
        "fr": "meilleur",
        "de": "beste",
        "it": "migliore",
        "pt": "melhor"
    },
    {
        "en": "to",
        "es": "a",
        "fr": "à",
        "de": "zu",
        "it": "a",
        "pt": "para"
    },
    {
        "en": "maximum",
        "es": "máximo",
        "fr": "maximum",
        "de": "Maximum",
        "it": "massimo",
        "pt": "máximo"
    },
    {
        "en": "piece",
        "es": "pieza",
        "fr": "pièce",
        "de": "Figur",
        "it": "pezzo",
        "pt": "peça"
    },
    {
        "en": "name",
        "es": "nombre",
        "fr": "nom",
        "de": "Name",
        "it": "nome",
        "pt": "nome"
    },
    {
        "en": "needed",
        "es": "necesario",
        "fr": "nécessaire",
        "de": "benötigt",
        "it": "necessario",
        "pt": "necessário"
    },
    {
        "en": "including",
        "es": "incluyendo",
        "fr": "y compris",
        "de": "einschließlich",
        "it": "incluso",
        "pt": "incluindo"
    },
    {
        "en": "no",
        "es": "no",
        "fr": "non",
        "de": "nein",
        "it": "no",
        "pt": "não"
    },
    {
        "en": "disc",
        "es": "disco",
        "fr": "disque",
        "de": "Scheibe",
        "it": "disco",
        "pt": "disco"
    },
    {
        "en": "discs",
        "es": "discos",
        "fr": "disques",
        "de": "Scheiben",
        "it": "dischi",
        "pt": "discos"
    },
    {
        "en": "regular",
        "es": "normal",
        "fr": "normal",
        "de": "normal",
        "it": "normale",
        "pt": "regular"
    },
    {
        "en": "board",
        "es": "tablero",
        "fr": "plateau",
        "de": "Brett",
        "it": "scacchiera",
        "pt": "tabuleiro"
    },
    {
        "en": "pieces",
        "es": "piezas",
        "fr": "pièces",
        "de": "Figuren",
        "it": "pezzi",
        "pt": "peças"
    },
    {
        "en": "check",
        "es": "jaque",
        "fr": "échec",
        "de": "Schach",
        "it": "scacco",
        "pt": "xeque"
    },
    {
        "en": "mate",
        "es": "mate",
        "fr": "mat",
        "de": "Matt",
        "it": "scacco matto",
        "pt": "mate"
    },
    {
        "en": "promotes",
        "es": "corona",
        "fr": "promotion",
        "de": "befördert",
        "it": "promuove",
        "pt": "promove"
    },
    {
        "en": "yes",
        "es": "sí",
        "fr": "oui",
        "de": "ja",
        "it": "sì",
        "pt": "sim"
    },
    {
        "en": "has",
        "es": "tiene",
        "fr": "a",
        "de": "hat",
        "it": "ha",
        "pt": "tem"
    },
    {
        "en": "blank",
        "es": "vacío",
        "fr": "vide",
        "de": "leer",
        "it": "vuoto",
        "pt": "em branco"
    },
    {
        "en": "result",
        "es": "resultado",
        "fr": "résultat",
        "de": "Ergebnis",
        "it": "risultato",
        "pt": "resultado"
    },
    {
        "en": "seconds",
        "es": "segundos",
        "fr": "secondes",
        "de": "Sekunden",
        "it": "secondi",
        "pt": "segundos"
    },
    {
        "en": "connect",
        "es": "conectar",
        "fr": "connecter",
        "de": "verbinden",
        "it": "connetti",
        "pt": "conectar"
    },
    {
        "en": "disconnect",
        "es": "desconectar",
        "fr": "déconnecter",
        "de": "trennen",
        "it": "disconnetti",
        "pt": "desconectar"
    },
    {
        "en": "rapid",
        "es": "rápido",
        "fr": "rapide",
        "de": "rapid",
        "it": "rapido",
        "pt": "rápido"
    },
    {
        "en": "pairing",
        "es": "emparejamiento",
        "fr": "appariement",
        "de": "Paarung",
        "it": "accoppiamento",
        "pt": "emparelhamento"
    },
    {
        "en": "pair",
        "es": "pareja",
        "fr": "paire",
        "de": "Paar",
        "it": "coppia",
        "pt": "par"
    },
    {
        "en": "correspondence",
        "es": "por correspondencia",
        "fr": "correspondance",
        "de": "Korrespondenz",
        "it": "corrispondenza",
        "pt": "correspondência"
    },
    {
        "en": "open",
        "es": "abierto",
        "fr": "ouvert",
        "de": "offen",
        "it": "aperto",
        "pt": "aberto"
    },
    {
        "en": "games",
        "es": "partidas",
        "fr": "parties",
        "de": "Spiele",
        "it": "partite",
        "pt": "partidas"
    },
    {
        "en": "challenge",
        "es": "reto",
        "fr": "défi",
        "de": "Herausforderung",
        "it": "sfida",
        "pt": "desafio"
    },
    {
        "en": "friend",
        "es": "amigo",
        "fr": "ami",
        "de": "Freund",
        "it": "amico",
        "pt": "amigo"
    },
    {
        "en": "friends",
        "es": "amigos",
        "fr": "amis",
        "de": "Freunde",
        "it": "amici",
        "pt": "amigos"
    },
    {
        "en": "arena",
        "es": "arena",
        "fr": "arène",
        "de": "Arena",
        "it": "arena",
        "pt": "arena"
    },
    {
        "en": "tournament",
        "es": "torneo",
        "fr": "tournoi",
        "de": "Turnier",
        "it": "torneo",
        "pt": "torneio"
    },
    {
        "en": "tournaments",
        "es": "torneos",
        "fr": "tournois",
        "de": "Turniere",
        "it": "tornei",
        "pt": "torneios"
    },
    {
        "en": "robot",
        "es": "robot",
        "fr": "robot",
        "de": "Roboter",
        "it": "robot",
        "pt": "robô"
    },
    {
        "en": "join",
        "es": "unirse",
        "fr": "rejoindre",
        "de": "beitreten",
        "it": "unisciti",
        "pt": "entrar"
    },
    {
        "en": "leave",
        "es": "salir",
        "fr": "quitter",
        "de": "verlassen",
        "it": "lascia",
        "pt": "sair"
    },
    {
        "en": "go",
        "es": "ir",
        "fr": "aller",
        "de": "los",
        "it": "vai",
        "pt": "ir"
    },
    {
        "en": "refresh",
        "es": "actualizar",
        "fr": "rafraîchir",
        "de": "aktualisieren",
        "it": "aggiorna",
        "pt": "atualizar"
    },
    {
        "en": "time",
        "es": "tiempo",
        "fr": "temps",
        "de": "Zeit",
        "it": "tempo",
        "pt": "tempo"
    },
    {
        "en": "control",
        "es": "control",
        "fr": "contrôle",
        "de": "Kontrolle",
        "it": "controllo",
        "pt": "controle"
    },
    {
        "en": "rated",
        "es": "calificado",
        "fr": "classé",
        "de": "bewertet",
        "it": "classificata",
        "pt": "classificado"
    },
    {
        "en": "random",
        "es": "aleatorio",
        "fr": "aléatoire",
        "de": "zufällig",
        "it": "casuale",
        "pt": "aleatório"
    },
    {
        "en": "minutes",
        "es": "minutos",
        "fr": "minutes",
        "de": "Minuten",
        "it": "minuti",
        "pt": "minutos"
    },
    {
        "en": "and",
        "es": "y",
        "fr": "et",
        "de": "und",
        "it": "e",
        "pt": "e"
    },
    {
        "en": "second",
        "es": "segundo",
        "fr": "seconde",
        "de": "Sekunde",
        "it": "secondo",
        "pt": "segundo"
    },
    {
        "en": "sec",
        "es": "seg",
        "fr": "sec",
        "de": "Sek",
        "it": "sec",
        "pt": "seg"
    },
    {
        "en": "increment",
        "es": "incremento",
        "fr": "supplémentaire",
        "de": "zusätzlich",
        "it": "incremento",
        "pt": "incremento"
    },
    {
        "en": "abort",
        "es": "abortar",
        "fr": "annuler",
        "de": "abbrechen",
        "it": "interrompi",
        "pt": "abortar"
    },
    {
        "en": "resign",
        "es": "rendirse",
        "fr": "abandonner",
        "de": "aufgeben",
        "it": "abbandona",
        "pt": "desistir"
    },
    {
        "en": "draw",
        "es": "tablas",
        "fr": "nul",
        "de": "Remis",
        "it": "patta",
        "pt": "empate"
    },
    {
        "en": "offer",
        "es": "ofrecer",
        "fr": "proposer",
        "de": "anbieten",
        "it": "offri",
        "pt": "oferta"
    },
    {
        "en": "offered",
        "es": "ofrecido",
        "fr": "proposé",
        "de": "angeboten",
        "it": "offerto",
        "pt": "oferecido"
    },
    {
        "en": "accept",
        "es": "aceptar",
        "fr": "accepter",
        "de": "akzeptieren",
        "it": "accetta",
        "pt": "aceitar"
    },
    {
        "en": "bot",
        "es": "bot",
        "fr": "bot",
        "de": "Bot",
        "it": "bot",
        "pt": "bot"
    },
    {
        "en": "off",
        "es": "apagado",
        "fr": "désactivé",
        "de": "aus",
        "it": "spento",
        "pt": "desligado"
    },
    {
        "en": "coordinate",
        "es": "coordenada",
        "fr": "coordonnée",
        "de": "Koordinate",
        "it": "coordinata",
        "pt": "coordenada"
    },
    {
        "en": "coordinates",
        "es": "coordenadas",
        "fr": "coordonnées",
        "de": "Koordinaten",
        "it": "coordinate",
        "pt": "coordenadas"
    },
    {
        "en": "chessvis",
        "es": "chessvis",
        "fr": "chessvis",
        "de": "chessvis",
        "it": "chessvis",
        "pt": "chessvis"
    },
    {
        "en": "colors",
        "es": "colores",
        "fr": "couleurs",
        "de": "Farben",
        "it": "colori",
        "pt": "cores"
    },
    {
        "en": "select",
        "es": "seleccionar",
        "fr": "sélectionner",
        "de": "auswählen",
        "it": "seleziona",
        "pt": "selecionar"
    },
    {
        "en": "voices",
        "es": "voces",
        "fr": "voix",
        "de": "Stimmen",
        "it": "voci",
        "pt": "vozes"
    },
    {
        "en": "words",
        "es": "palabras",
        "fr": "mots",
        "de": "Wörter",
        "it": "parole",
        "pt": "palavras"
    },
    {
        "en": "contact",
        "es": "contacto",
        "fr": "contact",
        "de": "Kontakt",
        "it": "contatto",
        "pt": "contato"
    },
    {
        "en": "terms",
        "es": "términos",
        "fr": "conditions",
        "de": "Bedingungen",
        "it": "termini",
        "pt": "termos"
    },
    {
        "en": "cancel",
        "es": "cancelar",
        "fr": "annuler",
        "de": "abbrechen",
        "it": "annulla",
        "pt": "cancelar"
    },
    {
        "en": "light",
        "es": "claro",
        "fr": "clair",
        "de": "hell",
        "it": "chiaro",
        "pt": "claro"
    },
    {
        "en": "night",
        "es": "noche",
        "fr": "nuit",
        "de": "nacht",
        "it": "notte",
        "pt": "escuro"
    },
    {
        "en": "inside",
        "es": "dentro",
        "fr": "intérieur",
        "de": "innen",
        "it": "interno",
        "pt": "dentro"
    },
    {
        "en": "outside",
        "es": "fuera",
        "fr": "extérieur",
        "de": "außen",
        "it": "esterno",
        "pt": "fora"
    },
    {
        "en": "none",
        "es": "ninguno",
        "fr": "aucun",
        "de": "keine",
        "it": "nessuno",
        "pt": "nenhum"
    },
    {
        "en": "set",
        "es": "ajustar",
        "fr": "définir",
        "de": "einstellen",
        "it": "imposta",
        "pt": "definir"
    },
    {
        "en": "player",
        "es": "jugador",
        "fr": "joueur",
        "de": "Spieler",
        "it": "giocatore",
        "pt": "jogador"
    },
    {
        "en": "voice",
        "es": "voz",
        "fr": "voix",
        "de": "Stimme",
        "it": "voce",
        "pt": "voz"
    },
    {
        "en": "names",
        "es": "nombres",
        "fr": "noms",
        "de": "Namen",
        "it": "nomi",
        "pt": "nomes"
    },
    {
        "en": "letters",
        "es": "letras",
        "fr": "lettres",
        "de": "Buchstaben",
        "it": "lettere",
        "pt": "letras"
    },
    {
        "en": "remember",
        "es": "recordar",
        "fr": "se souvenir",
        "de": "merken",
        "it": "ricorda",
        "pt": "lembrar"
    },
    {
        "en": "email",
        "es": "correo electrónico",
        "fr": "email",
        "de": "E-Mail",
        "it": "email",
        "pt": "email"
    },
    {
        "en": "address",
        "es": "dirección",
        "fr": "adresse",
        "de": "Adresse",
        "it": "indirizzo",
        "pt": "endereço"
    },
    {
        "en": "confirm",
        "es": "confirmar",
        "fr": "confirmer",
        "de": "bestätigen",
        "it": "conferma",
        "pt": "confirmar"
    },
    {
        "en": "forgot",
        "es": "olvidé",
        "fr": "oublié",
        "de": "vergessen",
        "it": "dimenticato",
        "pt": "esqueci"
    },
    {
        "en": "password",
        "es": "contraseña",
        "fr": "mot de passe",
        "de": "Passwort",
        "it": "password",
        "pt": "senha"
    },
    {
        "en": "list",
        "es": "lista",
        "fr": "liste",
        "de": "Liste",
        "it": "lista",
        "pt": "lista"
    },
    {
        "en": "say",
        "es": "decir",
        "fr": "dire",
        "de": "sagen",
        "it": "di'",
        "pt": "dizer"
    },
    {
        "en": "casual",
        "es": "amistosa",
        "fr": "amical",
        "de": "casual",
        "it": "informale",
        "pt": "casual"
    },
    {
        "en": "highlight",
        "es": "resaltar",
        "fr": "mettre en évidence",
        "de": "hervorheben",
        "it": "evidenzia",
        "pt": "destacar"
    },
    {
        "en": "now",
        "es": "ahora",
        "fr": "maintenant",
        "de": "jetzt",
        "it": "ora",
        "pt": "agora"
    },
    {
        "en": "mins",
        "es": "min",
        "fr": "min",
        "de": "Min",
        "it": "min",
        "pt": "min"
    },
    {
        "en": "players",
        "es": "jugadores",
        "fr": "joueurs",
        "de": "Spieler",
        "it": "giocatori",
        "pt": "jogadores"
    },
    {
        "en": "hourly",
        "es": "cada hora",
        "fr": "horaire",
        "de": "stündlich",
        "it": "ogni ora",
        "pt": "por hora"
    },
    {
        "en": "days",
        "es": "días",
        "fr": "jours",
        "de": "Tage",
        "it": "giorni",
        "pt": "dias"
    },
    {
        "en": "issue",
        "es": "emitir",
        "fr": "émission",
        "de": "ausstellen",
        "it": "emesso",
        "pt": "problema"
    },
    {
        "en": "declined",
        "es": "rechazado",
        "fr": "refusé",
        "de": "abgelehnt",
        "it": "rifiutato",
        "pt": "recusado"
    },
    {
        "en": "accepted",
        "es": "aceptado",
        "fr": "accepté",
        "de": "akzeptiert",
        "it": "accettato",
        "pt": "aceito"
    },
    {
        "en": "expired",
        "es": "expirado",
        "fr": "expiré",
        "de": "abgelaufen",
        "it": "scaduto",
        "pt": "expirado"
    },
    {
        "en": "send",
        "es": "enviar",
        "fr": "envoyer",
        "de": "senden",
        "it": "invia",
        "pt": "enviar"
    },
    {
        "en": "again",
        "es": "otra vez",
        "fr": "à nouveau",
        "de": "nochmals",
        "it": "di nuovo",
        "pt": "novamente"
    },
    {
        "en": "response",
        "es": "respuesta",
        "fr": "réponse",
        "de": "Antwort",
        "it": "risposta",
        "pt": "resposta"
    },
    {
        "en": "issued",
        "es": "emitido",
        "fr": "émis",
        "de": "ausgestellt",
        "it": "emesso",
        "pt": "emitido"
    },
    {
        "en": "created",
        "es": "creado",
        "fr": "créé",
        "de": "erstellt",
        "it": "creato",
        "pt": "criado"
    },
    {
        "en": "not",
        "es": "no",
        "fr": "non",
        "de": "nicht",
        "it": "non",
        "pt": "não"
    },
    {
        "en": "subscription",
        "es": "suscripcién",
        "fr": "abonnement",
        "de": "Abonnement",
        "it": "abbonamento",
        "pt": "assinatura"
    },
    {
        "en": "language",
        "es": "idioma",
        "fr": "langue",
        "de": "Sprache",
        "it": "lingua",
        "pt": "idioma"
    },
    {
        "en": "selection",
        "es": "seleccién",
        "fr": "sélection",
        "de": "Auswahl",
        "it": "selezione",
        "pt": "seleção"
    },
    {
        "en": "system",
        "es": "sistema",
        "fr": "système",
        "de": "System",
        "it": "sistema",
        "pt": "sistema"
    },
    {
        "en": "english",
        "es": "inglés",
        "fr": "anglais",
        "de": "Englisch",
        "it": "inglese",
        "pt": "inglês"
    },
    {
        "en": "spanish",
        "es": "español",
        "fr": "espagnol",
        "de": "Spanisch",
        "it": "spagnolo",
        "pt": "espanhol"
    },
    {
        "en": "speaking",
        "es": "hablando",
        "fr": "parlant",
        "de": "sprechend",
        "it": "parlante",
        "pt": "falando"
    },
    {
        "en": "menu",
        "es": "menô",
        "fr": "menu",
        "de": "Menü",
        "it": "menu",
        "pt": "menu"
    },
    {
        "en": "hear",
        "es": "oír",
        "fr": "entendre",
        "de": "hören",
        "it": "ascolta",
        "pt": "escutar"
    },
    {
        "en": "current",
        "es": "actual",
        "fr": "actuel",
        "de": "aktuell",
        "it": "attuale",
        "pt": "atual"
    },
    {
        "en": "update",
        "es": "actualizar",
        "fr": "mettre à jour",
        "de": "aktualisieren",
        "it": "aggiorna",
        "pt": "atualizar"
    },
    {
        "en": "signed",
        "es": "conectado",
        "fr": "connecté",
        "de": "angemeldet",
        "it": "connesso",
        "pt": "conectado"
    },
    {
        "en": "checking",
        "es": "comprobando",
        "fr": "vérification",
        "de": "prüfen",
        "it": "controllando",
        "pt": "verificando"
    },
    {
        "en": "welcome",
        "es": "bienvenido",
        "fr": "bienvenue",
        "de": "willkommen",
        "it": "benvenuto",
        "pt": "bem-vindo"
    },
    {
        "en": "click",
        "es": "clic",
        "fr": "cliquer",
        "de": "klicken",
        "it": "clicca",
        "pt": "clique"
    },
    {
        "en": "or",
        "es": "o",
        "fr": "ou",
        "de": "oder",
        "it": "o",
        "pt": "ou"
    },
    {
        "en": "registering",
        "es": "registrándose",
        "fr": "inscription",
        "de": "registrieren",
        "it": "registrazione",
        "pt": "registrando"
    },
    {
        "en": "verify",
        "es": "verificar",
        "fr": "vérifier",
        "de": "verifizieren",
        "it": "verifica",
        "pt": "verificar"
    },
    {
        "en": "subscribing",
        "es": "suscribiéndose",
        "fr": "abonnement",
        "de": "abonniert",
        "it": "abbonamento",
        "pt": "assinando"
    },
    {
        "en": "verified",
        "es": "verificado",
        "fr": "vérifié",
        "de": "verifiziert",
        "it": "verificato",
        "pt": "verificado"
    },
    {
        "en": "perpetual",
        "es": "perpetuo",
        "fr": "perpétuel",
        "de": "ewig",
        "it": "perpetuo",
        "pt": "perpétuo"
    },
    {
        "en": "lifetime",
        "es": "de por vida",
        "fr": "à vie",
        "de": "lebenslang",
        "it": "a vita",
        "pt": "vitalício"
    },
    {
        "en": "annual",
        "es": "anual",
        "fr": "annuel",
        "de": "jährlich",
        "it": "annuale",
        "pt": "anual"
    },
    {
        "en": "monthly",
        "es": "mensual",
        "fr": "mensuel",
        "de": "monatlich",
        "it": "mensile",
        "pt": "mensal"
    },
    {
        "en": "year",
        "es": "año",
        "fr": "année",
        "de": "Jahr",
        "it": "anno",
        "pt": "ano"
    },
    {
        "en": "month",
        "es": "mes",
        "fr": "mois",
        "de": "Monat",
        "it": "mese",
        "pt": "mês"
    },
    {
        "en": "choices",
        "es": "opciones",
        "fr": "choix",
        "de": "Optionen",
        "it": "scelte",
        "pt": "escolhas"
    },
    {
        "en": "explanation",
        "es": "explicacién",
        "fr": "explication",
        "de": "Erklärung",
        "it": "spiegazione",
        "pt": "explicação"
    },
    {
        "en": "translated",
        "es": "traducido",
        "fr": "traduit",
        "de": "übersetzt",
        "it": "tradotto",
        "pt": "traduzido"
    },
    {
        "en": "german",
        "es": "alemán",
        "it": "tedesco",
        "de": "Deutsch",
        "fr": "allemand",
        "pt": "alemão"
    },
    {
        "en": "italian",
        "es": "italiano",
        "it": "italiano",
        "de": "Italienisch",
        "fr": "italien",
        "pt": "italiano"
    },
    {
        "en": "french",
        "es": "francés",
        "it": "francese",
        "de": "Französisch",
        "fr": "français",
        "pt": "francês"
    },
    {
        "en": "a",
        "es": "a",
        "it": "a",
        "fr": "a",
        "de": "a",
        "pt": "a"
    },
    {
        "en": "b",
        "es": "be",
        "it": "bi",
        "fr": "bé",
        "de": "be",
        "pt": "b"
    },
    {
        "en": "c",
        "es": "ce",
        "it": "ci",
        "fr": "cé",
        "de": "ce",
        "pt": "c"
    },
    {
        "en": "d",
        "es": "de",
        "it": "di",
        "fr": "dé",
        "de": "de",
        "pt": "d"
    },
    {
        "en": "e",
        "es": "e",
        "it": "e",
        "fr": "e",
        "de": "e",
        "pt": "e"
    },
    {
        "en": "f",
        "es": "efe",
        "it": "effe",
        "fr": "effe",
        "de": "f",
        "pt": "f"
    },
    {
        "en": "g",
        "es": "ge",
        "it": "gi",
        "fr": "gé",
        "de": "ge",
        "pt": "g"
    },
    {
        "en": "h",
        "es": "hache",
        "it": "acca",
        "fr": "hache",
        "de": "ha",
        "pt": "h"
    },
    {
        "en": "user",
        "es": "usuario",
        "fr": "utilisateur",
        "de": "Benutzer",
        "it": "utente",
        "pt": "usuário"
    },
    {
        "en": "hi",
        "es": "hola",
        "fr": "salut",
        "de": "hallo",
        "it": "ciao",
        "pt": "oi"
    },
    {
        "en": "enter",
        "es": "entrar",
        "fr": "entrer",
        "de": "eingeben",
        "it": "entrare",
        "pt": "entrar"
    },
    {
        "en": "reset",
        "es": "reiniciar",
        "fr": "réinitialiser",
        "de": "zurücksetzen",
        "it": "reimpostare",
        "pt": "redefinir"
    },
    {
        "en": "make",
        "es": "hacer",
        "fr": "faire",
        "de": "machen",
        "it": "fare",
        "pt": "fazer"
    },
    {
        "en": "loading",
        "es": "cargando",
        "fr": "chargement",
        "de": "laden",
        "it": "caricamento",
        "pt": "carregando"
    },
    {
        "en": "over",
        "es": "terminado",
        "fr": "terminé",
        "de": "beendet",
        "it": "finito",
        "pt": "acabou"
    },
    {
        "en": "winner",
        "es": "ganador",
        "fr": "gagnant",
        "de": "Gewinner",
        "it": "vincitore",
        "pt": "vencedor"
    },
    {
        "en": "waiting",
        "es": "esperando",
        "fr": "en attente",
        "de": "wartend",
        "it": "in attesa",
        "pt": "aguardando"
    },
    {
        "en": "timed",
        "es": "con tiempo",
        "fr": "chronométré",
        "de": "zeitbegrenzt",
        "it": "a tempo",
        "pt": "cronometrado"
    },
    {
        "en": "day",
        "es": "día",
        "fr": "jour",
        "de": "Tag",
        "it": "giorno",
        "pt": "dia"
    },
    {
        "en": "languages",
        "es": "idiomas",
        "fr": "langues",
        "de": "Sprachen",
        "it": "lingue",
        "pt": "idiomas"
    },
    {
        "en": "recognizer",
        "es": "reconocedor",
        "fr": "reconnaisseur",
        "de": "Erkenner",
        "it": "riconoscitore",
        "pt": "reconhecedor"
    },
    {
        "en": "practice",
        "es": "práctica",
        "fr": "pratique",
        "de": "übung",
        "it": "pratica",
        "pt": "praticar"
    },
    {
        "en": "speech",
        "es": "voz",
        "fr": "voix",
        "de": "Sprache",
        "it": "voce",
        "pt": "fala"
    },
    {
        "en": "heard",
        "es": "escuchado",
        "fr": "entendu",
        "de": "gehört",
        "it": "sentito",
        "pt": "ouvido"
    },
    {
        "en": "letter",
        "es": "letra",
        "fr": "lettre",
        "de": "Buchstabe",
        "it": "lettera",
        "pt": "letra"
    },
    {
    "en": "portuguese",
    "es": "portugués",
    "fr": "portugais",
    "de": "portugiesisch",
    "it": "portoghese",
    "pt": "português"
  }
]

const phraseJson = 
[
    {
        "en": "Welcome to Verbal Chess",
        "es": "Bienvenido a Verbal Chess",
        "fr": "Bienvenue sur Verbal Chess",
        "de": "Willkommen bei Verbal Chess",
        "it": "Benvenuto a Verbal Chess",
        "pt": "Bem-vindo ao Verbal Chess"
    },
    {
        "en": "Say",
        "es": "Di",
        "fr": "Dis",
        "de": "Sag",
        "it": "Di'",
        "pt": "Diga"
    },
    {
        "en": "Command Explain",
        "es": "Explica Comando",
        "fr": "Explique la commande",
        "de": "Befehl erklären",
        "it": "Spiega comando",
        "pt": "Explicação do comando"
    },
    {
        "en": "for help on any screen",
        "es": "para ayuda en cualquier pantalla",
        "fr": "pour de l'aide sur n'importe quel écran",
        "de": "für Hilfe auf jedem Bildschirm",
        "it": "per aiuto su qualsiasi schermata",
        "pt": "para ajuda em qualquer tela"
    },
    {
        "en": "Thanks for being a Subscriber! -- You have access to both Komodo & Stockfish Engines at all skill levels. Plus All Blindfold Stepping Stones",
        "es": "¡Gracias por ser suscriptor! -- Tienes acceso a los motores Komodo y Stockfish en todos los niveles. Además, todos los niveles de ajedrez a ciegas.",
        "fr": "Merci d'être abonné ! -- Vous avez accès aux moteurs Komodo et Stockfish à tous les niveaux. Plus tous les niveaux pour le jeu à l'aveugle.",
        "de": "Danke, dass du Abonnent bist! -- Du hast Zugriff auf die Komodo- und Stockfish-Motoren auf allen Spielstärken. Plus alle Blindfold-Level.",
        "it": "Grazie per essere abbonato! -- Hai accesso ai motori Komodo e Stockfish a tutti i livelli. Inoltre, tutti i livelli per il gioco a occhi chiusi.",
        "pt": "Obrigado por ser assinante! — Você tem acesso aos motores Komodo e Stockfish em todos os níveis. Além de todos os níveis 'stepping stone' para xadrez às cegas"
    },
    {
        "en": "Your free account gives access to the Komodo Engine at its easiest setting only. For blindfold chess, you'll have two 'stepping stone' levels. See the 'Subscribe' screen for all the subscriber benefits",
        "es": "Tu cuenta gratuita solo da acceso al motor Komodo en su nivel más fácil. Para ajedrez a ciegas tendrás dos niveles 'stepping stone'. Mira la pantalla 'Suscribirse' para todos los beneficios.",
        "fr": "Votre compte gratuit donne accès uniquement au moteur Komodo au niveau le plus facile. Pour les échecs à l'aveugle, vous aurez deux niveaux 'stepping stone'. Consultez l'écran 'S'abonner' pour tous les avantages.",
        "de": "Dein kostenloses Konto gibt nur Zugriff auf den Komodo-Motor im einfachsten Modus. Für Blindschach gibt es zwei 'Stepping Stone'-Level. Siehe den 'Abonnieren'-Bildschirm für alle Vorteile.",
        "it": "Il tuo account gratuito dà accesso solo al motore Komodo al livello più facile. Per gli scacchi a occhi chiusi avrai due livelli 'stepping stone'. Guarda lo schermo 'Iscriviti' per tutti i vantaggi.",
        "pt": "Sua conta gratuita dá acesso ao motor Komodo apenas na configuração mais fácil. Para xadrez às cegas, você terá dois níveis 'stepping stone'. Veja a tela 'Assinar' para todos os benefícios de assinante"
    },
    {
        "en": "Engines Menu",
        "es": "Menô de Motores",
        "fr": "Menu des moteurs",
        "de": "Motoren-Menü",
        "it": "Menu motori",
        "pt": "Menu de motores"
    },
    {
        "en": "Continue Game",
        "es": "Continuar Partida",
        "fr": "Continuer la partie",
        "de": "Spiel fortsetzen",
        "it": "Continua partita",
        "pt": "Continuar partida"
    },
    {
        "en": "Play Computer",
        "es": "Jugar contra la Computadora",
        "fr": "Jouer contre l'ordinateur",
        "de": "Gegen Computer spielen",
        "it": "Gioca contro il computer",
        "pt": "Jogar contra o computador"
    },
    {
        "en": "Play Blindfold",
        "es": "Jugar a Ciegas",
        "fr": "Jouer à l'aveugle",
        "de": "Blind spielen",
        "it": "Gioca a occhi chiusi",
        "pt": "Jogar às cegas"
    },
    {
        "en": "Make Move",
        "es": "Hacer Mocién",
        "fr": "Faire un coup",
        "de": "Zug machen",
        "it": "Fai mossa",
        "pt": "Fazer jogada"
    },
    {
        "en": "No Play Keyword Required",
        "es": "No se necesita palabra clave para jugar",
        "fr": "Pas besoin de mot-clé pour jouer",
        "de": "Kein Spiel-Schlüsselwort nötig",
        "it": "Non serve parola chiave per giocare",
        "pt": "Não é preciso dizer a palavra 'play'"
    },
    {
        "en": "Just say e4 or echo 4",
        "es": "Solo di e4 o eco 4",
        "fr": "Dites juste e4 ou écho 4",
        "de": "Sag einfach e4 oder Echo 4",
        "it": "Di' solo e4 o eco 4",
        "pt": "Apenas diga e4 ou 'echo 4'"
    },
    {
        "en": "Say piece name even if pawn",
        "es": "Di el nombre de la pieza incluso si es peén",
        "fr": "Dites le nom de la pièce même si c'est un pion",
        "de": "Sag den Figurenname, auch wenn Bauer",
        "it": "Di' il nome del pezzo anche se è pedone",
        "pt": "Diga o nome da peça, mesmo se for um peão"
    },
    {
        "en": "Pawn e4 or Pawn echo 4",
        "es": "Peén e4 o Peén eco 4",
        "fr": "Pion e4 ou Pion écho 4",
        "de": "Bauer e4 oder Bauer Echo 4",
        "it": "Pedone e4 o Pedone eco 4",
        "pt": "Peão e4 ou Peão echo 4"
    },
    {
        "en": "Play Keyword Required",
        "es": "Se necesita palabra clave para jugar",
        "fr": "Mot-clé requis pour jouer",
        "de": "Spiel-Schlüsselwort erforderlich",
        "it": "Serve parola chiave per giocare",
        "pt": "É preciso usar a palavra 'play'"
    },
    {
        "en": "Say 'play e4' or 'play echo 4'",
        "es": "Di 'juega e4' o 'juega eco 4'",
        "fr": "Dites 'joue e4' ou 'joue écho 4'",
        "de": "Sag 'spiele e4' oder 'spiele Echo 4'",
        "it": "Di' 'gioca e4' o 'gioca eco 4'",
        "pt": "Diga 'play e4' ou 'play echo 4'"
    },
    {
        "en": "Play as White",
        "es": "Jugar como Blancas",
        "fr": "Jouer avec les Blancs",
        "de": "Als Weiß spielen",
        "it": "Gioca con i Bianchi",
        "pt": "Jogar de branco"
    },
    {
        "en": "Play as Black",
        "es": "Jugar como Negras",
        "fr": "Jouer avec les Noirs",
        "de": "Als Schwarz spielen",
        "it": "Gioca con i Neri",
        "pt": "Jogar de preto"
    },
    {
        "en": "Komodo (Best To Start) Engine",
        "es": "Motor Komodo (Mejor para empezar)",
        "fr": "Moteur Komodo (meilleur pour commencer)",
        "de": "Komodo-Motor (Am besten zum Starten)",
        "it": "Motore Komodo (Migliore per iniziare)",
        "pt": "Motor Komodo (melhor para começar)"
    },
    {
        "en": "Stockfish Engine",
        "es": "Motor Stockfish",
        "fr": "Moteur Stockfish",
        "de": "Stockfish-Motor",
        "it": "Motore Stockfish",
        "pt": "Motor Stockfish"
    },
    {
        "en": "Using",
        "es": "Usando",
        "fr": "Utilisation de",
        "de": "Verwendet",
        "it": "Usando",
        "pt": "Usando"
    },
    {
        "en": "Skill",
        "es": "Habilidad",
        "fr": "Compétence",
        "de": "Fähigkeit",
        "it": "Abilità",
        "pt": "Nível"
    },
    {
        "en": "Maximum",
        "es": "Máximo",
        "fr": "Maximum",
        "de": "Maximum",
        "it": "Massimo",
        "pt": "Máximo"
    },
    {
        "en": "Rating Equivalent",
        "es": "Equivalente de ELO",
        "fr": "équivalent de classement",
        "de": "Bewertungsäquivalent",
        "it": "Equivalente di ELO",
        "pt": "Equivalente de rating"
    },
    {
        "en": "Loading Tour Explanation Pages",
        "es": "Cargando páginas de explicacién del tour",
        "fr": "Chargement des pages d'explication du tutoriel",
        "de": "Lade Tour-Erklärungsseiten",
        "it": "Caricamento pagine spiegazione tour",
        "pt": "Carregando páginas de explicação do tour"
    },
    {
        "en": "Game Review",
        "es": "Revisién de Partida",
        "fr": "Revue de la partie",
        "de": "Partie-überprüfung",
        "it": "Revisione partita",
        "pt": "Revisão da partida"
    },
    {
        "en": "Regular Pieces",
        "es": "Piezas normales",
        "fr": "Pièces normales",
        "de": "Normale Figuren",
        "it": "Pezzi normali",
        "pt": "Peças normais"
    },
    {
        "en": "One Color Pieces",
        "es": "Piezas de un solo color",
        "fr": "Pièces d'une seule couleur",
        "de": "Einfarbige Figuren",
        "it": "Pezzi di un solo colore",
        "pt": "Peças de uma cor"
    },
    {
        "en": "Two Color Discs",
        "es": "Fichas de dos colores",
        "fr": "Pions de deux couleurs",
        "de": "Zweifarbige Steine",
        "it": "Pedine di due colori",
        "pt": "Discos de duas cores"
    },
    {
        "en": "One Color Disc",
        "es": "Ficha de un solo color",
        "fr": "Pion d'une seule couleur",
        "de": "Einfarbiger Stein",
        "it": "Pedina di un solo colore",
        "pt": "Disco de uma cor"
    },
    {
        "en": "Empty Board",
        "es": "Tablero vacío",
        "fr": "Plateau vide",
        "de": "Leeres Brett",
        "it": "Scacchiera vuota",
        "pt": "Tabuleiro vazio"
    },
    {
        "en": "1 : Komodo - Best To Start",
        "es": "1 : Komodo - Mejor para empezar",
        "fr": "1 : Komodo - Meilleur pour commencer",
        "de": "1 : Komodo - Am besten zum Starten",
        "it": "1 : Komodo - Migliore per iniziare",
        "pt": "1 : Komodo - Melhor para começar"
    },
    {
        "en": "2 : Stockfish",
        "es": "2 : Stockfish",
        "fr": "2 : Stockfish",
        "de": "2 : Stockfish",
        "it": "2 : Stockfish",
        "pt": "2 : Stockfish"
    },
    {
        "en": "Not Blind",
        "es": "No es a ciegas",
        "fr": "Pas à l'aveugle",
        "de": "Nicht blind",
        "it": "Non a occhi chiusi",
        "pt": "Não às cegas"
    },
    {
        "en": "Shared Piece",
        "es": "Pieza compartida",
        "fr": "Pièce partagée",
        "de": "Geteilte Figur",
        "it": "Pezzo condiviso",
        "pt": "Peça compartilhada"
    },
    {
        "en": "Two Discs",
        "es": "Dos fichas",
        "fr": "Deux pions",
        "de": "Zwei Steine",
        "it": "Due pedine",
        "pt": "Dois discos"
    },
    {
        "en": "Shared Disc",
        "es": "Ficha compartida",
        "fr": "Pion partagé",
        "de": "Geteilter Stein",
        "it": "Pedina condivisa",
        "pt": "Disco compartilhado"
    },
    {
        "en": "Shall we play a game?",
        "es": "¿Jugamos una partida?",
        "fr": "On joue une partie ?",
        "de": "Wollen wir eine Partie spielen?",
        "it": "Giochiamo una partita?",
        "pt": "Vamos jogar uma partida?"
    },
    {
        "en": "Black's Move",
        "es": "Turno de las negras",
        "fr": "Coup des Noirs",
        "de": "Zug der Schwarzen",
        "it": "Mossa dei Neri",
        "pt": "Vez das pretas"
    },
    {
        "en": "White's Move",
        "es": "Turno de las blancas",
        "fr": "Coup des Blancs",
        "de": "Zug der Weißen",
        "it": "Mossa dei Bianchi",
        "pt": "Vez das brancas"
    },
    {
        "en": "End Game?",
        "es": "¿Terminar partida?",
        "fr": "Terminer la partie ?",
        "de": "Partie beenden?",
        "it": "Terminare la partita?",
        "pt": "Encerrar partida?"
    },
    {
        "en": "locate needs color",
        "es": "buscar necesita color",
        "fr": "recherche nécessite couleur",
        "de": "Suche benötigt Farbe",
        "it": "cerca ha bisogno di colore",
        "pt": "o comando 'locate' precisa da cor"
    },
    {
        "en": "locate needs piece name",
        "es": "buscar necesita nombre de pieza",
        "fr": "recherche nécessite nom de pièce",
        "de": "Suche benötigt Figurenname",
        "it": "cerca ha bisogno del nome del pezzo",
        "pt": "o comando 'locate' precisa do nome da peça"
    },
    {
        "en": "rank not understood",
        "es": "rango no entendido",
        "fr": "rang non compris",
        "de": "Reihe nicht verstanden",
        "it": "rango non capito",
        "pt": "rank não entendido"
    },
    {
        "en": "file not understood",
        "es": "columna no entendida",
        "fr": "colonne non comprise",
        "de": "Spalte nicht verstanden",
        "it": "colonna non capita",
        "pt": "coluna (file) não entendida"
    },
    {
        "en": "is empty",
        "es": "está vacío",
        "fr": "est vide",
        "de": "ist leer",
        "it": "è vuoto",
        "pt": "está vazia"
    },
    {
        "en": "not on board",
        "es": "no está en el tablero",
        "fr": "pas sur le plateau",
        "de": "nicht auf dem Brett",
        "it": "non sulla scacchiera",
        "pt": "não está no tabuleiro"
    },
    {
        "en": "Loading Game History",
        "es": "Cargando historial de partidas",
        "fr": "Chargement de l'historique des parties",
        "de": "Lade Partieverlauf",
        "it": "Caricamento cronologia partite",
        "pt": "Carregando histórico de partidas"
    },
    {
        "en": "Initializing Speech Recognizer",
        "es": "Inicializando reconocimiento de voz",
        "fr": "Initialisation de la reconnaissance vocale",
        "de": "Spracherkennung initialisieren",
        "it": "Inizializzazione riconoscimento vocale",
        "pt": "Inicializando reconhecedor de voz"
    },
    {
        "en": "Downloading Language Model",
        "es": "Descargando modelo de lenguaje",
        "fr": "Téléchargement du modèle de langue",
        "de": "Sprachmodell herunterladen",
        "it": "Download modello linguistico",
        "pt": "Baixando modelo de linguagem"
    },
    {
        "en": "Waiting on Microphone Access",
        "es": "Esperando acceso al micrófono",
        "fr": "En attente d'accès au micro",
        "de": "Warte auf Mikrofonzugriff",
        "it": "In attesa accesso microfono",
        "pt": "Aguardando acesso ao microfone"
    },
    {
        "en": "Got Microphone Access",
        "es": "Acceso al micréfono concedido",
        "fr": "Accès au micro obtenu",
        "de": "Mikrofonzugriff erhalten",
        "it": "Accesso microfono ottenuto",
        "pt": "Acesso ao microfone concedido"
    },
    {
        "en": "No Microphone Access. Click & Tap still works.",
        "es": "Sin acceso al micréfono. Hacer clic o tocar todavía funciona.",
        "fr": "Pas d'accès au micro. Cliquer ou toucher fonctionne toujours.",
        "de": "Kein Mikrofonzugriff. Klick & Tippen funktioniert weiterhin.",
        "it": "Nessun accesso al microfono. Clic e tocco funzionano comunque.",
        "pt": "Sem acesso ao microfone. Clique e toque ainda funcionam."
    },
    {
        "en": "For IOS & Android, Click Button to Initialize the Audio System",
        "es": "Para iOS y Android, pulsa el botén para iniciar el sistema de audio",
        "fr": "Pour iOS et Android, cliquez sur le bouton pour lancer le système audio",
        "de": "Für iOS & Android, klicke auf den Button, um das Audiosystem zu starten",
        "it": "Per iOS e Android, clicca il pulsante per inizializzare l'audio",
        "pt": "Para iOS e Android, clique no botão para inicializar o sistema de áudio"
    },
    {
        "en": "Note: speech recognition needs access to the microphone. Nothing is recorded or saved.",
        "es": "Nota: el reconocimiento de voz necesita acceso al micréfono. Nada se graba ni se guarda.",
        "fr": "Remarque : la reconnaissance vocale a besoin du micro. Rien n'est enregistré ou sauvegardé.",
        "de": "Hinweis: Spracherkennung benötigt Mikrofonzugriff. Nichts wird aufgezeichnet oder gespeichert.",
        "it": "Nota: il riconoscimento vocale ha bisogno del microfono. Nulla viene registrato o salvato.",
        "pt": "Obs.: o reconhecimento de voz precisa de acesso ao microfone. Nada é gravado ou salvo."
    },
    {
        "en": "Note: the speech recognition language model is 41 megabytes.",
        "es": "Nota: el modelo de lenguaje del reconocimiento de voz ocupa 41 megabytes.",
        "fr": "Remarque : le modèle de langage fait 41 mégaoctets.",
        "de": "Hinweis: Das Sprachmodell ist 41 Megabyte groß.",
        "it": "Nota: il modello linguistico è di 41 megabyte.",
        "pt": "Obs.: o modelo de linguagem do reconhecimento de voz tem 41 megabytes."
    },
    {
        "en": "Downloading could take a few seconds, possibly up to 30 seconds. Once downloaded, it will be available instantly in the future.",
        "es": "La descarga puede tardar unos segundos, hasta 30 segundos. Una vez descargado, estará disponible al instante en el futuro.",
        "fr": "Le téléchargement peut prendre quelques secondes, jusqu'à 30 s. Une fois téléchargé, il sera disponible instantanément à l'avenir.",
        "de": "Der Download kann ein paar Sekunden dauern, eventuell bis zu 30 Sekunden. Nach dem Herunterladen ist es zukünftig sofort verfügbar.",
        "it": "Il download potrebbe richiedere pochi secondi, fino a 30. Una volta scaricato, sarà disponibile subito in futuro.",
        "pt": "O download pode levar alguns segundos, possivelmente até 30 segundos. Depois de baixado, ficará disponível instantaneamente no futuro."
    },
    {
        "en": "Time downloading",
        "es": "Tiempo de descarga",
        "fr": "Temps de téléchargement",
        "de": "Download-Zeit",
        "it": "Tempo di download",
        "pt": "Tempo de download"
    },
    {
        "en": "To Lichess - (Access expired)",
        "es": "A Lichess - (Acceso expirado)",
        "fr": "Vers Lichess - (Accès expiré)",
        "de": "Zu Lichess - (Zugriff abgelaufen)",
        "it": "Verso Lichess - (Accesso scaduto)",
        "pt": "Para Lichess - (Acesso expirado)"
    },
    {
        "en": "Loading Lichess Friends List",
        "es": "Cargando lista de amigos de Lichess",
        "fr": "Chargement de la liste d'amis Lichess",
        "de": "Lade Lichess-Freundesliste",
        "it": "Caricamento lista amici Lichess",
        "pt": "Carregando lista de amigos do Lichess"
    },
    {
        "en": "Loading Lichess Arena Tournaments",
        "es": "Cargando torneos Arena de Lichess",
        "fr": "Chargement des tournois Arena Lichess",
        "de": "Lade Lichess Arena-Turniere",
        "it": "Caricamento tornei Arena Lichess",
        "pt": "Carregando Torneios Arena do Lichess"
    },
    {
        "en": "Tournaments Starting Soon",
        "es": "Torneos empezando pronto",
        "fr": "Tournois bientôt disponibles",
        "de": "Turniere starten bald",
        "it": "Tornei in partenza presto",
        "pt": "Torneios começando em breve"
    },
    {
        "en": "Tournaments On Right Now",
        "es": "Torneos en curso ahora",
        "fr": "Tournois en cours",
        "de": "Turniere die gerade laufen",
        "it": "Tornei in corso ora",
        "pt": "Torneios acontecendo agora"
    },
    {
        "en": "Piece Name Required - Including Pawn",
        "es": "Se necesita nombre de pieza - incluye peén",
        "fr": "Nom de la pièce requis - y compris le pion",
        "de": "Figurenname erforderlich - inklusive Bauer",
        "it": "Nome pezzo richiesto - include pedone",
        "pt": "Nome da peça obrigatório — inclusive peão"
    },
    {
        "en": "When Challenge Accepted, it will be in your 'Open Games' list",
        "es": "Cuando se acepte el reto, aparecerá en tu lista de 'Partidas abiertas'",
        "fr": "Quand le défi est accepté, il apparaîtra dans votre liste 'Parties ouvertes'",
        "de": "Wenn die Herausforderung angenommen wird, erscheint sie in deiner 'Offene Partien'-Liste",
        "it": "Quando la sfida è accettata, apparirà nella tua lista 'Partite aperte'",
        "pt": "Quando o desafio for aceito, ele ficará na sua lista 'Jogos Abertos'"
    },
    {
        "en": "File Words - instead of letters",
        "es": "Palabras de columna - en lugar de letras",
        "fr": "Mots de colonne - au lieu des lettres",
        "de": "Spalten-Wörter - statt Buchstaben",
        "it": "Parole di colonna - invece delle lettere",
        "pt": "Palavras para colunas — em vez de letras"
    },
    {
        "en": "Terms of Service",
        "es": "Términos de servicio",
        "fr": "Conditions d'utilisation",
        "de": "Nutzungsbedingungen",
        "it": "Termini di servizio",
        "pt": "Termos de Serviço"
    },
    {
        "en": "Account Menu",
        "es": "Menô de cuenta",
        "fr": "Menu du compte",
        "de": "Konto-Menü",
        "it": "Menu account",
        "pt": "Menu da conta"
    },
    {
        "en": "When you ' Update ' the language, the program will restart!",
        "es": "Cuando 'actualices' el idioma, el programa se reiniciará!",
        "fr": "Quand vous 'mettez à jour' la langue, le programme redémarrera !",
        "de": "Wenn du die Sprache 'aktualisierst', wird das Programm neu gestartet!",
        "it": "Quando 'aggiorni' la lingua, il programma si riavvierà!",
        "pt": "Quando você 'Atualizar' o idioma, o programa será reiniciado!"
    },
    {
        "en": "Please Sign In -- (Note: Email\/Password same as Chessvis)",
        "es": "Por favor inicia sesién -- (Nota: Email\/contraseña igual que Chessvis)",
        "fr": "Veuillez vous connecter -- (Remarque : email\/mot de passe identiques à Chessvis)",
        "de": "Bitte anmelden -- (Hinweis: E-Mail\/Passwort wie bei Chessvis)",
        "it": "Accedi per favore -- (Nota: Email\/password uguali a Chessvis)",
        "pt": "Por favor, faça login — (Obs.: Email\/Senha igual ao Chessvis)"
    },
    {
        "en": "Email is not in the system",
        "es": "El correo no está en el sistema",
        "fr": "L'email n'est pas dans le système",
        "de": "E-Mail ist nicht im System",
        "it": "Email non presente nel sistema",
        "pt": "Email não está no sistema"
    },
    {
        "en": "Password is incorrect",
        "es": "Contraseña incorrecta",
        "fr": "Mot de passe incorrect",
        "de": "Passwort ist falsch",
        "it": "Password non corretta",
        "pt": "Senha incorreta"
    },
    {
        "en": "Please enter your email address",
        "es": "Por favor ingresa tu correo electrénico",
        "fr": "Veuillez entrer votre email",
        "de": "Bitte E-Mail-Adresse eingeben",
        "it": "Inserisci la tua email",
        "pt": "Por favor, insira seu endereço de email"
    },
    {
        "en": "Password Reset Email Sent",
        "es": "Correo de restablecimiento de contraseña enviado",
        "fr": "Email de réinitialisation du mot de passe envoyé",
        "de": "Passwort-Zurücksetzungs-Mail gesendet",
        "it": "Email per reset password inviata",
        "pt": "Email de redefinição de senha enviado"
    },
    {
        "en": "Please enter your password",
        "es": "Por favor ingresa tu contraseña",
        "fr": "Veuillez entrer votre mot de passe",
        "de": "Bitte Passwort eingeben",
        "it": "Inserisci la tua password",
        "pt": "Por favor, insira sua senha"
    },
    {
        "en": "Email is already in the system. Please Login",
        "es": "El correo ya está registrado. Por favor inicia sesién",
        "fr": "Email déjà enregistré. Veuillez vous connecter",
        "de": "E-Mail ist bereits registriert. Bitte anmelden",
        "it": "Email già registrata. Accedi per favore",
        "pt": "Email já consta no sistema. Por favor, faça login"
    },
    {
        "en": "Passwords don't match",
        "es": "Las contraseñas no coinciden",
        "fr": "Les mots de passe ne correspondent pas",
        "de": "Passwörter stimmen nicht überein",
        "it": "Le password non coincidono",
        "pt": "As senhas não coincidem"
    },
    {
        "en": "Please Register",
        "es": "Por favor regístrate",
        "fr": "Veuillez vous inscrire",
        "de": "Bitte registrieren",
        "it": "Registrati per favore",
        "pt": "Por favor, registre-se"
    },
    {
        "en": "Sending Verification Email",
        "es": "Enviando correo de verificacién",
        "fr": "Envoi de l'email de vérification",
        "de": "Verifizierungsmail wird gesendet",
        "it": "Invio email di verifica",
        "pt": "Enviando email de verificação"
    },
    {
        "en": "To Subscribe, please verify your email address",
        "es": "Para suscribirte, verifica tu correo electrénico",
        "fr": "Pour vous abonner, vérifiez votre email",
        "de": "Um zu abonnieren, bestätige deine E-mail",
        "it": "Per iscriverti, verifica la tua email",
        "pt": "Para assinar, verifique seu email"
    },
    {
        "en": "Please Verify to Subscribe",
        "es": "Por favor verifica para suscribirte",
        "fr": "Veuillez vérifier pour vous abonner",
        "de": "Bitte bestätigen, um zu abonnieren",
        "it": "Verifica per iscriverti",
        "pt": "Por favor, verifique para assinar"
    },
    {
        "en": "When you're done with that page, you should automatically be back in Verbal Chess.",
        "es": "Cuando termines con esa página, deberías volver automáticamente a Verbal Chess.",
        "fr": "Quand vous aurez fini cette page, vous reviendrez automatiquement sur Verbal Chess.",
        "de": "Wenn du mit dieser Seite fertig bist, solltest du automatisch wieder in Verbal Chess sein.",
        "it": "Quando finisci quella pagina, tornerai automaticamente su Verbal Chess.",
        "pt": "Quando terminar nessa página, você voltará automaticamente para o Verbal Chess."
    },
    {
        "en": "After clicking one of the following buttons, or saying",
        "es": "Después de hacer clic en uno de los siguientes botones, o decir",
        "fr": "Après avoir cliqué sur l'un des boutons suivants ou dit",
        "de": "Nachdem du auf einen der folgenden Buttons geklickt hast oder gesagt hast",
        "it": "Dopo aver cliccato uno dei seguenti pulsanti o detto",
        "pt": "Depois de clicar em um dos botões abaixo, ou dizer"
    },
    {
        "en": "you'll be taken to the secure 'Stripe.com' website. (This might take a couple of seconds.)",
        "es": "serás llevado al sitio seguro 'Stripe.com'. (Esto puede tardar unos segundos.)",
        "fr": "vous serez redirigé vers le site sécurisé 'Stripe.com'. (Cela peut prendre quelques secondes.)",
        "de": "wirst du zur sicheren 'Stripe.com'-Website weitergeleitet. (Das kann ein paar Sekunden dauern.)",
        "it": "verrai portato al sito sicuro 'Stripe.com'. (Questo potrebbe richiedere qualche secondo.)",
        "pt": "você será redirecionado para o site seguro 'Stripe.com'. (Isto pode demorar alguns segundos.)"
    },
    {
        "en": "Password Reset Request",
        "es": "Solicitud de restablecimiento de contraseña",
        "fr": "Demande de réinitialisation du mot de passe",
        "de": "Anforderung zum Zurücksetzen des Passworts",
        "it": "Richiesta di reimpostazione della password",
        "pt": "Solicitação de redefinição de senha"
    },
    {
        "en": "To reset your password within the 'Verbal Chess' website, either click on the link below or copy it into your browser and it will take you to a password reset page.",
        "es": "Para restablecer tu contraseña en el sitio 'Verbal Chess', haz clic en el enlace de abajo o cópialo en tu navegador y te llevará a la página para cambiar la contraseña.",
        "fr": "Pour réinitialiser votre mot de passe sur le site 'Verbal Chess', cliquez sur le lien ci-dessous ou copiez-le dans votre navigateur et vous serez dirigé vers la page de réinitialisation du mot de passe.",
        "de": "Um Ihr Passwort auf der Website 'Verbal Chess' zurückzusetzen, klicken Sie auf den untenstehenden Link oder kopieren Sie ihn in Ihren Browser, um zur Passwort-Zurücksetzungsseite zu gelangen.",
        "it": "Per reimpostare la tua password sul sito 'Verbal Chess', clicca sul link qui sotto oppure copialo nel tuo browser e verrai portato alla pagina di reimpostazione della password.",
        "pt": "Para redefinir sua senha no site 'Verbal Chess', clique no link abaixo ou copie-o no navegador; ele levará você a uma página de redefinição de senha."
    },
    {
        "en": "If that doesn't work, this is the old link that does the same thing but uses the Chessvis.com site. Then you can manually go back to the new web site.",
        "es": "Si eso no funciona, este es el enlace antiguo que hace lo mismo pero usa el sitio Chessvis.com. Luego puedes volver manualmente al nuevo sitio web.",
        "fr": "Si cela ne fonctionne pas, voici l'ancien lien qui fait la même chose mais utilise le site Chessvis.com. Ensuite, vous pouvez revenir manuellement sur le nouveau site.",
        "de": "Falls das nicht funktioniert, ist dies der alte Link, der dasselbe tut, aber die Chessvis.com-Seite verwendet. Dann können Sie manuell zur neuen Website zurückkehren.",
        "it": "Se non funziona, questo è il vecchio link che fa la stessa cosa ma utilizza il sito Chessvis.com. Poi puoi tornare manualmente al nuovo sito web.",
        "pt": "Se isso não funcionar, este é o link antigo que faz a mesma coisa, mas usa o site Chessvis.com. Depois você pode voltar manualmente para o novo site."
    },
    {
        "en": "If you have any questions, please email me at",
        "es": "Si tienes alguna pregunta, envíame un correo a",
        "fr": "Si vous avez des questions, envoyez-moi un email à",
        "de": "Wenn Sie Fragen haben, senden Sie mir bitte eine E-Mail an",
        "it": "Se hai domande, inviami un'email a",
        "pt": "Se tiver alguma dúvida, por favor me envie um email para"
    },
    {
        "en": "Cancel any open sessions on other devices. (Not needed if you only forgot your password)",
        "es": "Cancelar cualquier sesión abierta en otros dispositivos. (No es necesario si solo olvidaste tu contraseña)",
        "fr": "Annuler toutes les sessions ouvertes sur d'autres appareils. (Non nécessaire si vous avez seulement oublié votre mot de passe)",
        "de": "Alle offenen Sitzungen auf anderen Geräten abbrechen. (Nicht erforderlich, wenn Sie nur Ihr Passwort vergessen haben)",
        "it": "Annulla eventuali sessioni aperte su altri dispositivi. (Non necessario se hai solo dimenticato la password)",
        "pt": "Cancele quaisquer sessões abertas em outros dispositivos. (Não é necessário se você apenas esqueceu a senha)"
    },
    {
        "en": "resetting password",
        "es": "restableciendo contraseña",
        "fr": "réinitialisation du mot de passe",
        "de": "Passwort wird zurückgesetzt",
        "it": "reimpostazione della password",
        "pt": "redefinindo senha"
    },
    {
        "en": "Password Reset. Please use the 'Login' screen with the new password.",
        "es": "Contraseña restablecida. Por favor, usa la pantalla de 'Iniciar sesión' con la nueva contraseña.",
        "fr": "Mot de passe réinitialisé. Veuillez utiliser l'écran de 'Connexion' avec le nouveau mot de passe.",
        "de": "Passwort zurückgesetzt. Bitte verwenden Sie den 'Login'-Bildschirm mit dem neuen Passwort.",
        "it": "Password reimpostata. Per favore usa la schermata di 'Login' con la nuova password.",
        "pt": "Senha redefinida. Por favor, use a tela 'Login' com a nova senha."
    },
    {
        "en": "To verify your email address with the Verbal Chess website, either click on the link below or copy it into your browser. It will bring up a webpage that will register your verification.",
        "es": "Para verificar tu correo electrónico en el sitio Verbal Chess, haz clic en el enlace de abajo o cópialo en tu navegador. Se abrirá una página web que registrará tu verificación.",
        "fr": "Pour vérifier votre adresse e-mail sur le site Verbal Chess, cliquez sur le lien ci-dessous ou copiez-le dans votre navigateur. Une page web s'ouvrira pour enregistrer votre vérification.",
        "de": "Um Ihre E-Mail-Adresse auf der Verbal Chess-Website zu verifizieren, klicken Sie auf den untenstehenden Link oder kopieren Sie ihn in Ihren Browser. Eine Webseite wird geöffnet, um Ihre Verifizierung zu registrieren.",
        "it": "Per verificare il tuo indirizzo email sul sito Verbal Chess, clicca sul link qui sotto o copialo nel browser. Si aprirà una pagina web che registrerà la tua verifica.",
        "pt": "Para verificar seu email no site Verbal Chess, clique no link abaixo ou copie-o no navegador. Isso abrirá uma página que registrará sua verificação."
    },
    {
        "en": "no email associated with account",
        "es": "ningún correo asociado con la cuenta",
        "fr": "aucun e-mail associé au compte",
        "de": "kein E-Mail-Konto verbunden",
        "it": "nessuna email associata all'account",
        "pt": "nenhum email associado à conta"
    },
    {
        "en": "verification email sent",
        "es": "correo de verificación enviado",
        "fr": "e-mail de vérification envoyé",
        "de": "Verifizierungs-E-Mail gesendet",
        "it": "email di verifica inviata",
        "pt": "email de verificação enviado"
    },
    {
        "en": "Email Verification Request",
        "es": "Solicitud de verificación de correo",
        "fr": "Demande de vérification de l'e-mail",
        "de": "Anfrage zur E-Mail-Verifizierung",
        "it": "Richiesta di verifica dell'email",
        "pt": "Solicitação de verificação de email"
    },
    {
        "en": "processing email verification",
        "es": "procesando verificación de correo",
        "fr": "traitement de la vérification de l'e-mail",
        "de": "E-Mail-Verifizierung wird bearbeitet",
        "it": "elaborazione della verifica email",
        "pt": "processando verificação de email"
    },
    {
        "en": "Email Verified",
        "es": "Correo verificado",
        "fr": "E-mail vérifié",
        "de": "E-Mail verifiziert",
        "it": "Email verificata",
        "pt": "Email verificado"
    },
    {
        "en": "Email Verification Check",
        "es": "Comprobación de verificación de correo",
        "fr": "Vérification de l'e-mail",
        "de": "Überprüfung der E-Mail-Verifizierung",
        "it": "Controllo verifica email",
        "pt": "Verificação de email"
    },
    {
        "en": "Email Verification",
        "es": "Verificación de correo",
        "fr": "Vérification de l'e-mail",
        "de": "E-Mail-Verifizierung",
        "it": "Verifica dell'email",
        "pt": "Verificação de email"
    },
    {
        "en": "You are back in Verbal Chess",
        "es": "Has vuelto a Verbal Chess",
        "fr": "Vous êtes de retour dans Verbal Chess",
        "de": "Du bist zurück in Verbal Chess",
        "it": "Sei tornato in Verbal Chess",
        "pt": "Você voltou para o Verbal Chess"
    },
    {
        "en": "Subscribe Cancel",
        "es": "Cancelar suscripción",
        "fr": "Annuler l'abonnement",
        "de": "Abonnement kündigen",
        "it": "Annulla abbonamento",
        "pt": "Cancelar assinatura"
    },
    {
        "en": "Subscribing Success",
        "es": "Suscripción exitosa",
        "fr": "Abonnement réussi",
        "de": "Abonnement erfolgreich",
        "it": "Abbonamento riuscito",
        "pt": "Assinatura realizada com sucesso"
    },
    {
        "en": "Thank you for Subscribing",
        "es": "Gracias por suscribirte",
        "fr": "Merci pour votre abonnement",
        "de": "Danke für dein Abonnement",
        "it": "Grazie per esserti abbonato",
        "pt": "Obrigado por assinar"
    },
    {
        "en": "This should be reflected on the main menu",
        "es": "Esto debería reflejarse en el menú principal",
        "fr": "Cela devrait se refléter dans le menu principal",
        "de": "Dies sollte im Hauptmenü angezeigt werden",
        "it": "Questo dovrebbe essere visibile nel menu principale",
        "pt": "Isso deve aparecer no menu principal"
    },
    {
        "en": "no engine move to repeat",
        "es": "ningún movimiento del motor para repetir",
        "fr": "aucun coup du moteur à répéter",
        "de": "kein Engine-Zug zum Wiederholen",
        "it": "nessuna mossa del motore da ripetere",
        "pt": "nenhuma jogada do motor para repetir"
    },
    {
        "en": "Loading Open Game List",
        "es": "Cargando la lista de partidas abiertas",
        "fr": "Chargement de la liste des parties ouvertes",
        "de": "Offene Spiel-Liste wird geladen",
        "it": "Caricamento della lista delle partite aperte",
        "pt": "Carregando lista de jogos abertos"
    },
    {
        "en": "No Open Games",
        "es": "No hay partidas abiertas",
        "fr": "Aucune partie ouverte",
        "de": "Keine offenen Spiele",
        "it": "Nessuna partita aperta",
        "pt": "Nenhum jogo aberto"
    },
    {
        "en": "Waiting for Lichess Stream to Finish",
        "es": "Esperando a que termine la transmisión de Lichess",
        "fr": "En attente de la fin du flux Lichess",
        "de": "Warten, bis der Lichess-Stream beendet ist",
        "it": "In attesa che lo streaming di Lichess finisca",
        "pt": "Aguardando o fim da transmissão do Lichess"
    },
    {
        "en": "Can Take Up to Six Seconds",
        "es": "Puede tardar hasta seis segundos",
        "fr": "Cela peut prendre jusqu'à six secondes",
        "de": "Kann bis zu sechs Sekunden dauern",
        "it": "Può richiedere fino a sei secondi",
        "pt": "Pode levar até seis segundos"
    },
    {
        "en": "no opponent move to repeat",
        "es": "ningún movimiento del oponente para repetir",
        "fr": "aucun coup de l'adversaire à répéter",
        "de": "kein Zug des Gegners zum Wiederholen",
        "it": "nessuna mossa dell'avversario da ripetere",
        "pt": "nenhuma jogada do oponente para repetir"
    },
    {
        "en": "Loading Lichess Challenge Options",
        "es": "Cargando opciones de desafío de Lichess",
        "fr": "Chargement des options de défi Lichess",
        "de": "Lichess-Herausforderungsoptionen werden geladen",
        "it": "Caricamento delle opzioni di sfida Lichess",
        "pt": "Carregando opções de desafio do Lichess"
    },
    {
        "en": "Learn what the speech recognizer hears",
        "es": "Aprende lo que escucha el reconocedor de voz",
        "fr": "Découvrez ce que reconnaît le reconnaisseur vocal",
        "de": "Erfahre, was der Spracherkenner hört",
        "it": "Scopri cosa sente il riconoscitore vocale",
        "pt": "Saiba o que o reconhecedor de voz ouve"
    },
    {
        "en": "Say the words from ' play the computer '",
        "es": "Di las palabras de 'jugar contra la computadora'",
        "fr": "Prononce les mots de 'jouer contre l'ordinateur'",
        "de": "Sprich die Worte 'gegen den Computer spielen'",
        "it": "Pronuncia le parole di 'giocare contro il computer'",
        "pt": "Diga as palavras de 'play the computer'"
    },
    {
        "en": "on file",
        "es": "en la columna",
        "fr": "sur la colonne",
        "de": "auf der Linie",
        "it": "sulla colonna",
        "pt": "na coluna"
    },
    {
        "en": "on rank",
        "es": "en la fila",
        "fr": "sur la rangée",
        "de": "auf der Reihe",
        "it": "sulla traversa",
        "pt": "na fileira"
    },
    {
        "en": "and on rank",
        "es": "y en la fila",
        "fr": "et sur la rangée",
        "de": "und auf der Reihe",
        "it": "e sulla traversa",
        "pt": "e na fileira"
    },
    {
        "en": "Your browser has blocked Verbal Chess from using the microphone",
        "es": "Tu navegador ha bloqueado a Verbal Chess para que no use el micrófono",
        "fr": "Votre navigateur a bloqué Verbal Chess pour l'utilisation du microphone",
        "de": "Dein Browser hat Verbal Chess daran gehindert, das Mikrofon zu benutzen",
        "it": "Il tuo browser ha bloccato Verbal Chess dall'uso del microfono",
        "pt": "Seu navegador bloqueou o Verbal Chess de usar o microfone"
    },
    {
        "en": "Your browser does not support getUserMedia API",
        "es": "Tu navegador no admite la API getUserMedia",
        "fr": "Votre navigateur ne prend pas en charge l'API getUserMedia",
        "de": "Dein Browser unterstützt die getUserMedia-API nicht",
        "it": "Il tuo browser non supporta l'API getUserMedia",
        "pt": "Seu navegador não suporta a API getUserMedia"
    },
  {
    "en": "Home",
    "es": "Inicio",
    "fr": "Accueil",
    "de": "Startseite",
    "it": "Home",
    "pt": "Início"
  },
  {
    "en": "Features",
    "es": "Funciones",
    "fr": "Fonctionnalités",
    "de": "Funktionen",
    "it": "Funzioni",
    "pt": "Recursos"
  },
  {
    "en": "Videos",
    "es": "Videos",
    "fr": "Vidéos",
    "de": "Videos",
    "it": "Video",
    "pt": "Vídeos"
  },
  {
    "en": "The World's Only Fully Voice-Controlled Chess App",
    "es": "La única aplicación de ajedrez totalmente controlada por voz del mundo",
    "fr": "La seule application d’échecs entièrement contrôlée par la voix au monde",
    "de": "Die einzige komplett sprachgesteuerte Schach-App der Welt",
    "it": "L’unica app di scacchi al mondo completamente controllata con la voce",
    "pt": "O único aplicativo de xadrez totalmente controlado por voz do mundo"
  },
  {
    "en": "Experience chess like never before - with your voice!",
    "es": "Vive el ajedrez como nunca antes, ¡con tu voz!",
    "fr": "Découvrez les échecs comme jamais auparavant — avec votre voix !",
    "de": "Erlebe Schach wie nie zuvor – mit deiner Stimme!",
    "it": "Vivi gli scacchi come mai prima d’ora, con la tua voce!",
    "pt": "Experimente o xadrez como nunca antes — com a sua voz!"
  },
  {
    "en": "Download For Android",
    "es": "Descargar para Android",
    "fr": "Télécharger pour Android",
    "de": "Für Android herunterladen",
    "it": "Scarica per Android",
    "pt": "Baixar para Android"
  },
  {
    "en": "Download For IOS",
    "es": "Descargar para iOS",
    "fr": "Télécharger pour iOS",
    "de": "Für iOS herunterladen",
    "it": "Scarica per iOS",
    "pt": "Baixar para iOS"
  },
  {
    "en": "Play on the Web - Now",
    "es": "Juega en la web - ahora",
    "fr": "Jouez sur le web - dès maintenant",
    "de": "Spiele im Web – jetzt",
    "it": "Gioca sul web - ora",
    "pt": "Jogue na web - agora"
  },
  {
    "en": "Start Playing Now",
    "es": "Empieza a jugar ya",
    "fr": "Commencez à jouer dès maintenant",
    "de": "Starte jetzt dein Spiel",
    "it": "Inizia subito a giocare",
    "pt": "Comece a jogar agora mesmo"
  },
  {
    "en": "Play While You Do Other Things!",
    "es": "¡Juega mientras haces lo que te gusta!",
    "fr": "Jouez tout en faisant ce que vous aimez !",
    "de": "Spiel, während du dein Ding machst!",
    "it": "Gioca mentre fai altro!",
    "pt": "Jogue enquanto faz o que quiser!"
  },
  {
    "en": "Why stop life to play chess? With Verbal Chess, your moves flow naturally through voice commands. Cook dinner, go for a walk, or relax on the beach -- all While staying fully engaged in your match. Chess becomes part of your lifestyle, not a disruption.",
    "es": "¿Por qué detener tu vida para jugar ajedrez? Con Verbal Chess, tus movimientos fluyen naturalmente con la voz. Cocina, sal a caminar o relájate en la playa, todo mientras sigues en la partida. El ajedrez se integra a tu vida, no la interrumpe.",
    "fr": "Pourquoi mettre votre vie en pause pour jouer aux échecs ? Avec Verbal Chess, vos coups s’enchaînent naturellement grâce à la voix. Cuisinez, promenez-vous ou détendez-vous sur la plage tout en restant dans la partie. Les échecs s’intègrent à votre quotidien.",
    "de": "Warum das Leben anhalten, um Schach zu spielen? Mit Verbal Chess fließen deine Züge natürlich per Sprachbefehl. Koch, geh spazieren oder entspann dich am Strand – und bleib trotzdem mitten im Spiel. Schach wird Teil deines Lebens, nicht eine Pause davon.",
    "it": "Perché fermarti per giocare a scacchi? Con Verbal Chess le mosse scorrono naturalmente con la voce. Prepara la cena, fai una passeggiata o rilassati in spiaggia, restando sempre nel gioco. Gli scacchi entrano nel tuo stile di vita.",
    "pt": "Por que parar a vida para jogar xadrez? Com o Verbal Chess, seus lances fluem naturalmente com a voz. Cozinhe, caminhe ou relaxe na praia — tudo sem sair da partida. O xadrez vira parte do seu dia a dia, não uma pausa dele."
  },
  {
    "en": "Cook dinner and call your moves hand-free",
    "es": "Prepara la cena y haz tus jugadas sin usar las manos",
    "fr": "Préparez le dîner et jouez sans les mains",
    "de": "Koche dein Abendessen und spiel freihändig",
    "it": "Prepara la cena e gioca senza usare le mani",
    "pt": "Prepare o jantar e jogue sem usar as mãos"
  },
  {
    "en": "Stay Active while keeping your mind sharp",
    "es": "Mantente activo y tu mente despierta",
    "fr": "Restez actif tout en gardant l’esprit vif",
    "de": "Bleib in Bewegung und halte deinen Geist scharf",
    "it": "Resta attivo e tieni la mente allenata",
    "pt": "Mantenha-se ativo e com a mente afiada"
  },
  {
    "en": "Relax anywhere -- no screen tapping required",
    "es": "Relájate donde quieras — sin tocar la pantalla",
    "fr": "Détendez-vous où que vous soyez — sans toucher l’écran",
    "de": "Entspann dich überall – ganz ohne Bildschirmtippen",
    "it": "Rilassati ovunque — senza toccare lo schermo",
    "pt": "Relaxe em qualquer lugar — sem precisar tocar na tela"
  },
  {
    "en": "Sneak in a match during a break at work",
    "es": "Aprovecha un descanso y juega una partida rápida",
    "fr": "Glissez une petite partie pendant votre pause au travail",
    "de": "Spiel eine schnelle Partie in deiner Arbeitspause",
    "it": "Fai una partita veloce durante la pausa in ufficio",
    "pt": "Aproveite o intervalo no trabalho para jogar uma partida rápida"
  },
   {
    "en": "See Verbal Chess in Action",
    "es": "Mira Verbal Chess en acción",
    "fr": "Découvrez Verbal Chess en action",
    "de": "Erlebe Verbal Chess in Aktion",
    "it": "Guarda Verbal Chess in azione",
    "pt": "Veja o Verbal Chess em ação"
  },
  {
    "en": "Want to see how Verbal Chess works in real-time? What these quick 30-second demos showcasing the power of voice control in action. Experience how Playing chess can be easier, more fun, and more accessible.",
    "es": "¿Quieres ver cómo funciona Verbal Chess en tiempo real? Mira estas demos rápidas de 30 segundos que muestran el poder del control por voz. Descubre cómo jugar ajedrez puede ser más fácil, divertido y accesible.",
    "fr": "Envie de voir comment Verbal Chess fonctionne en temps réel ? Regardez ces démos de 30 secondes qui montrent toute la puissance du contrôle vocal. Découvrez à quel point jouer aux échecs peut être plus simple, amusant et accessible.",
    "de": "Willst du sehen, wie Verbal Chess in Echtzeit funktioniert? Schau dir diese kurzen 30-Sekunden-Demos an und erlebe die Kraft der Sprachsteuerung. Entdecke, wie Schach einfacher, spannender und zugänglicher wird.",
    "it": "Vuoi vedere come funziona Verbal Chess in tempo reale? Guarda queste brevi demo di 30 secondi che mostrano la potenza del controllo vocale. Scopri come giocare a scacchi può essere più facile, divertente e accessibile.",
    "pt": "Quer ver como o Verbal Chess funciona em tempo real? Assista a esses vídeos curtos de 30 segundos que mostram o poder do controle por voz. Descubra como jogar xadrez pode ser mais fácil, divertido e acessível."
  },
  {
    "en": "Demonstrate how everything in the app is voice-controlled, not just the moves like navigating menus and settings",
    "es": "Muestra cómo todo en la app se controla por voz, no solo las jugadas, también los menús y ajustes",
    "fr": "Montrez que tout dans l’application est contrôlé par la voix, pas seulement les coups mais aussi la navigation dans les menus et les réglages",
    "de": "Zeige, dass in der App alles sprachgesteuert ist – nicht nur die Züge, sondern auch Menüs und Einstellungen",
    "it": "Mostra come tutto nell’app è controllato con la voce — non solo le mosse, ma anche i menu e le impostazioni",
    "pt": "Mostre como tudo no app é controlado por voz — não apenas os lances, mas também os menus e configurações"
  },
  {
    "en": "Navigate the Menus",
    "es": "Navega por los menús",
    "fr": "Naviguez dans les menus",
    "de": "Navigiere durch die Menüs",
    "it": "Naviga nei menu",
    "pt": "Navegue pelos menus"
  },
  {
    "en": "Play a Few Moves",
    "es": "Haz unas cuantas jugadas",
    "fr": "Jouez quelques coups",
    "de": "Mach ein paar Züge",
    "it": "Fai qualche mossa",
    "pt": "Faça algumas jogadas"
  },
  {
    "en": "Show how the player can issue voice commands to make moves on the chessboard.",
    "es": "Muestra cómo el jugador puede usar comandos de voz para mover las piezas en el tablero.",
    "fr": "Montrez comment le joueur peut donner des commandes vocales pour jouer ses coups sur l’échiquier.",
    "de": "Zeige, wie der Spieler per Sprachbefehl seine Züge auf dem Schachbrett ausführen kann.",
    "it": "Mostra come il giocatore può usare i comandi vocali per muovere i pezzi sulla scacchiera.",
    "pt": "Mostre como o jogador pode usar comandos de voz para mover as peças no tabuleiro."
  },
  {
    "en": "Play Around the World",
    "es": "Juega con personas de todo el mundo",
    "fr": "Jouez contre le monde entier",
    "de": "Spiel gegen Gegner auf der ganzen Welt",
    "it": "Gioca con persone da tutto il mondo",
    "pt": "Jogue com pessoas do mundo todo"
  },
  {
    "en": "In addition to playing the computer, play on Lichess.org against anyone around the world.",
    "es": "Además de jugar contra la computadora, juega en Lichess.org contra cualquier persona del mundo.",
    "fr": "En plus de jouer contre l’ordinateur, affrontez des joueurs du monde entier sur Lichess.org.",
    "de": "Neben dem Computer kannst du auf Lichess.org gegen Spieler aus aller Welt antreten.",
    "it": "Oltre a sfidare il computer, gioca su Lichess.org contro chiunque nel mondo.",
    "pt": "Além de jogar contra o computador, jogue no Lichess.org contra pessoas do mundo todo."
  },
  {
    "en": "Everyone Can Play Blindfold Chess",
    "es": "Todos pueden jugar ajedrez a ciegas",
    "fr": "Tout le monde peut jouer aux échecs à l’aveugle",
    "de": "Jeder kann Blindschach spielen",
    "it": "Tutti possono giocare a scacchi alla cieca",
    "pt": "Todos podem jogar xadrez às cegas"
  },
  {
    "en": "Showcase the Blindfold Chess feature. The player calls out the moves, while the board remains visualized mentally.",
    "es": "Muestra la función de ajedrez a ciegas. El jugador anuncia las jugadas mientras visualiza el tablero en su mente.",
    "fr": "Mettez en avant la fonction d’échecs à l’aveugle. Le joueur annonce ses coups tout en visualisant le plateau mentalement.",
    "de": "Präsentiere das Blindschach-Feature. Der Spieler sagt seine Züge an, während er das Brett im Kopf visualisiert.",
    "it": "Mostra la funzione di scacchi alla cieca. Il giocatore annuncia le mosse mentre visualizza la scacchiera mentalmente.",
    "pt": "Destaque o modo de xadrez às cegas. O jogador anuncia os lances enquanto visualiza o tabuleiro mentalmente."
  },
  {
    "en": "Chess for Everyone, Hands-Free!",
    "es": "¡Ajedrez para todos, sin usar las manos!",
    "fr": "Les échecs pour tous, sans les mains !",
    "de": "Schach für alle – ganz ohne Hände!",
    "it": "Scacchi per tutti, senza usare le mani!",
    "pt": "Xadrez para todos, sem usar as mãos!"
  },
  {
    "en": "Verbal Chess was built with inclusivity in mind. Whether you live with limited mobility, visual impairments, or simply prefer a hands-free experience, this app makes the timeless game of chess accessible to all. Every move, every option, and every feature is voice-enabled -- so no one is left behind.",
    "es": "Verbal Chess fue creado pensando en la inclusión. Ya sea que tengas movilidad reducida, dificultades visuales o simplemente prefieras una experiencia sin manos, esta app hace que el ajedrez sea accesible para todos. Cada movimiento, opción y función se controla por voz — para que nadie quede fuera.",
    "fr": "Verbal Chess a été conçu dans un esprit d’inclusion. Que vous ayez une mobilité réduite, une déficience visuelle ou que vous préfériez simplement jouer sans les mains, cette application rend les échecs accessibles à tous. Chaque coup, chaque option et chaque fonction est activé par la voix — personne n’est laissé de côté.",
    "de": "Verbal Chess wurde mit Inklusion im Sinn entwickelt. Egal ob du eingeschränkte Mobilität, Sehbeeinträchtigungen hast oder einfach freihändig spielen möchtest – diese App macht das Schachspiel für alle zugänglich. Jeder Zug, jede Option und jede Funktion ist sprachgesteuert – niemand bleibt außen vor.",
    "it": "Verbal Chess è stato creato con l’inclusività al centro. Che tu abbia mobilità ridotta, problemi di vista o semplicemente preferisca giocare senza usare le mani, questa app rende il gioco degli scacchi accessibile a tutti. Ogni mossa, ogni opzione e ogni funzione si controlla con la voce — nessuno resta indietro.",
    "pt": "O Verbal Chess foi desenvolvido com inclusão em mente. Seja você uma pessoa com mobilidade reduzida, deficiência visual ou que apenas prefira jogar sem usar as mãos, este app torna o xadrez acessível a todos. Cada lance, cada opção e cada recurso é controlado por voz — ninguém fica de fora."
  },
  {
    "en": "Designed with accessibility first",
    "es": "Diseñado con la accesibilidad como prioridad",
    "fr": "Conçu avec l’accessibilité avant tout",
    "de": "Mit Fokus auf Barrierefreiheit entwickelt",
    "it": "Progettato mettendo l’accessibilità al primo posto",
    "pt": "Projetado com foco na acessibilidade"
  },
  {
    "en": "Voice commands work across every game function",
    "es": "Los comandos de voz funcionan en todas las funciones del juego",
    "fr": "Les commandes vocales fonctionnent sur toutes les fonctions du jeu",
    "de": "Sprachbefehle funktionieren in allen Spielbereichen",
    "it": "I comandi vocali funzionano in tutte le funzioni del gioco",
    "pt": "Os comandos de voz funcionam em todas as funções do jogo"
  },
  {
    "en": "Bring chess to players who previously couldn't enjoy it",
    "es": "Lleva el ajedrez a quienes antes no podían disfrutarlo",
    "fr": "Apportez les échecs à ceux qui ne pouvaient pas en profiter auparavant",
    "de": "Bringe Schach zu Spielern, die es bisher nicht genießen konnten",
    "it": "Porta gli scacchi a chi prima non poteva goderne",
    "pt": "Leve o xadrez a quem antes não podia aproveitá-lo"
  },
  {
    "en": "Sneak in a match during a break at work",
    "es": "Aprovecha un descanso en el trabajo para una partida rápida",
    "fr": "Glissez une petite partie pendant votre pause au travail",
    "de": "Spiel eine schnelle Partie in deiner Arbeitspause",
    "it": "Fai una partita veloce durante la pausa al lavoro",
    "pt": "Aproveite o intervalo no trabalho para jogar uma partida rápida"
  },
  {
    "en": "What you can do with Verbal Chess",
    "es": "Lo que puedes hacer con Verbal Chess",
    "fr": "Ce que vous pouvez faire avec Verbal Chess",
    "de": "Was du mit Verbal Chess machen kannst",
    "it": "Cosa puoi fare con Verbal Chess",
    "pt": "O que você pode fazer com o Verbal Chess"
  },
  {
    "en": "Verbal Chess isn't just voice-controlled -- it's a complete chess experience. Play your way.",
    "es": "Verbal Chess no es solo control por voz — es una experiencia completa de ajedrez. Juega a tu manera.",
    "fr": "Verbal Chess n’est pas seulement contrôlé par la voix — c’est une expérience d’échecs complète. Jouez à votre façon.",
    "de": "Verbal Chess ist nicht nur sprachgesteuert — es ist ein komplettes Schacherlebnis. Spiel auf deine Art.",
    "it": "Verbal Chess non è solo controllo vocale — è un’esperienza di scacchi completa. Gioca come vuoi.",
    "pt": "O Verbal Chess não é apenas controlado por voz — é uma experiência completa de xadrez. Jogue do seu jeito."
  },
  {
    "en": "Play Against the Computer",
    "es": "Juega contra la computadora",
    "fr": "Jouez contre l’ordinateur",
    "de": "Spiel gegen den Computer",
    "it": "Gioca contro il computer",
    "pt": "Jogue contra o computador"
  },
  {
    "en": "From beginner-friendly levels to world-champion strength engines -- train, practice, and grow at your pace",
    "es": "Desde niveles para principiantes hasta motores con fuerza de campeón mundial: entrena, practica y mejora a tu ritmo",
    "fr": "Des niveaux pour débutants aux moteurs dignes d’un champion du monde — entraînez-vous, progressez et grandissez à votre rythme",
    "de": "Von einsteigerfreundlichen Stufen bis hin zu Weltmeister-Engines – trainiere, übe und wachse in deinem Tempo",
    "it": "Dai livelli per principianti ai motori di forza da campione del mondo: allenati, esercitati e cresci al tuo ritmo",
    "pt": "De níveis para iniciantes a motores com força de campeão mundial — treine, pratique e evolua no seu ritmo"
  },
  {
    "en": "Play Online with the World",
    "es": "Juega en línea con el mundo",
    "fr": "Jouez en ligne avec le monde entier",
    "de": "Spiel online mit der ganzen Welt",
    "it": "Gioca online con il mondo",
    "pt": "Jogue online com o mundo inteiro"
  },
  {
    "en": "Integrated with Lichess.org for 24/7 games. Find opponents worldwide, play fast or slow games, join tournaments or challenge friends.",
    "es": "Integrado con Lichess.org para jugar las 24 horas. Encuentra oponentes de todo el mundo, juega partidas rápidas o lentas, únete a torneos o reta a tus amigos.",
    "fr": "Intégré à Lichess.org pour jouer 24h/24. Trouvez des adversaires dans le monde entier, jouez des parties rapides ou lentes, rejoignez des tournois ou défiez vos amis.",
    "de": "Integriert mit Lichess.org für Spiele rund um die Uhr. Finde Gegner weltweit, spiele schnelle oder langsame Partien, tritt Turnieren bei oder fordere Freunde heraus.",
    "it": "Integrato con Lichess.org per partite 24 ore su 24. Trova avversari in tutto il mondo, gioca partite veloci o lente, partecipa a tornei o sfida gli amici.",
    "pt": "Integrado com o Lichess.org para partidas 24 horas por dia. Encontre adversários do mundo todo, jogue partidas rápidas ou lentas, participe de torneios ou desafie amigos."
  },
  {
    "en": "Play Blindfold Chess",
    "es": "Juega ajedrez a ciegas",
    "fr": "Jouez aux échecs à l’aveugle",
    "de": "Spiel Blindschach",
    "it": "Gioca a scacchi alla cieca",
    "pt": "Jogue xadrez às cegas"
  },
  {
    "en": "The original idea behind Verbal Chess. Close your eyes, say your move, and hear your opponent's response. Step-by-step training makes it achievable for everyone.",
    "es": "La idea original detrás de Verbal Chess. Cierra los ojos, di tu jugada y escucha la respuesta del rival. El entrenamiento paso a paso lo hace posible para todos.",
    "fr": "L’idée originale derrière Verbal Chess. Fermez les yeux, dites votre coup et écoutez la réponse de votre adversaire. Un entraînement progressif le rend accessible à tous.",
    "de": "Die ursprüngliche Idee hinter Verbal Chess. Schließe die Augen, sag deinen Zug und höre die Antwort deines Gegners. Schritt-für-Schritt-Training macht es für jeden machbar.",
    "it": "L’idea originale alla base di Verbal Chess. Chiudi gli occhi, annuncia la tua mossa e ascolta la risposta dell’avversario. L’allenamento graduale lo rende possibile per tutti.",
    "pt": "A ideia original por trás do Verbal Chess. Feche os olhos, diga sua jogada e ouça a resposta do oponente. O treino passo a passo torna isso acessível a todos."
  },
  {
    "en": "Why Verbal Chess is Unique",
    "es": "Por qué Verbal Chess es único",
    "fr": "Pourquoi Verbal Chess est unique",
    "de": "Warum Verbal Chess einzigartig ist",
    "it": "Perché Verbal Chess è unico",
    "pt": "Por que o Verbal Chess é único"
  },
  {
    "en": "Voice control allows you to focus on your game without being distracted by touching the screen. Perfect for multitaskers, users with disabilities, and anyone looking for a more immersive chess experience.",
    "es": "El control por voz te permite concentrarte en tu partida sin distraerte tocando la pantalla. Perfecto para multitareas, personas con discapacidades y cualquiera que busque una experiencia de ajedrez más inmersiva.",
    "fr": "Le contrôle vocal vous permet de vous concentrer sur votre partie sans être distrait par l’écran. Parfait pour les multitâches, les personnes en situation de handicap et tous ceux qui recherchent une expérience d’échecs plus immersive.",
    "de": "Die Sprachsteuerung ermöglicht es dir, dich voll auf dein Spiel zu konzentrieren, ohne vom Tippen auf den Bildschirm abgelenkt zu werden. Ideal für Multitasker, Menschen mit Behinderungen und alle, die ein intensiveres Schacherlebnis suchen.",
    "it": "Il controllo vocale ti consente di concentrarti sulla partita senza distrarti toccando lo schermo. Perfetto per chi fa più cose insieme, per persone con disabilità o chi vuole un’esperienza di scacchi più immersiva.",
    "pt": "O controle por voz permite que você se concentre no jogo sem se distrair tocando na tela. Perfeito para multitarefas, pessoas com deficiência e quem busca uma experiência de xadrez mais envolvente."
  },
  {
    "en": "Experience Verbal Chess Anywhere, Anytime",
    "es": "Disfruta de Verbal Chess en cualquier lugar y momento",
    "fr": "Découvrez Verbal Chess partout et à tout moment",
    "de": "Erlebe Verbal Chess überall und jederzeit",
    "it": "Vivi Verbal Chess ovunque e in qualsiasi momento",
    "pt": "Experimente o Verbal Chess em qualquer lugar e a qualquer hora"
  },
  {
    "en": "We are dedicated to broadening and developing chess as art, recreation, and as a significant element of culture.",
    "es": "Nos dedicamos a ampliar y desarrollar el ajedrez como arte, recreación y parte importante de la cultura.",
    "fr": "Nous nous engageons à promouvoir et développer les échecs comme art, loisir et élément essentiel de la culture.",
    "de": "Wir setzen uns dafür ein, Schach als Kunst, Freizeitbeschäftigung und wichtigen Teil der Kultur weiterzuentwickeln.",
    "it": "Ci impegniamo a diffondere e sviluppare gli scacchi come arte, svago e parte importante della cultura.",
    "pt": "Nos dedicamos a ampliar e desenvolver o xadrez como arte, lazer e parte importante da cultura."
  },
  {
    "en": "Ready to Play? Download Verbal Chess Now!",
    "es": "¿Listo para jugar? ¡Descarga Verbal Chess ahora!",
    "fr": "Prêt à jouer ? Téléchargez Verbal Chess dès maintenant !",
    "de": "Bereit zu spielen? Lade Verbal Chess jetzt herunter!",
    "it": "Pronto a giocare? Scarica subito Verbal Chess!",
    "pt": "Pronto para jogar? Baixe o Verbal Chess agora!"
  },
  {
    "en": "Contact us",
    "es": "Contáctanos",
    "fr": "Contactez-nous",
    "de": "Kontaktiere uns",
    "it": "Contattaci",
    "pt": "Fale conosco"
  },
  {
    "en": "Audio Context error. If you're using the 'Chrome' browser on Android, please try another browser. 'Verbal Chess' won't respond to voice commands but you can still tap and click.",
    "es": "Error de Audio Context. Si estás usando el navegador 'Chrome' en Android, prueba con otro navegador. 'Verbal Chess' no responderá a los comandos de voz, pero aún puedes tocar y hacer clic.",
    "fr": "Erreur Audio Context. Si vous utilisez le navigateur 'Chrome' sur Android, essayez un autre navigateur. 'Verbal Chess' ne répondra pas aux commandes vocales, mais vous pouvez toujours appuyer et cliquer.",
    "de": "Audio Context-Fehler. Wenn du den Browser 'Chrome' auf Android verwendest, probiere bitte einen anderen Browser. 'Verbal Chess' reagiert nicht auf Sprachbefehle, aber du kannst weiterhin tippen und klicken.",
    "it": "Errore di Audio Context. Se stai usando il browser 'Chrome' su Android, prova con un altro browser. 'Verbal Chess' non risponderà ai comandi vocali, ma puoi comunque toccare e fare clic.",
    "pt": "Erro de Audio Context. Se você estiver usando o navegador 'Chrome' no Android, tente outro navegador. O 'Verbal Chess' não responderá aos comandos de voz, mas você ainda pode tocar e clicar."
  },
   {
    "en": "not on move list",
    "es": "no está en la lista de movimientos",
    "fr": "pas dans la liste des coups",
    "de": "nicht in der Zugliste",
    "it": "non è nella lista delle mosse",
    "pt": "não está na lista de lances"
  }
]

/*

LAST STRING

*/
export function getLanguageString(languageInUse) {
  //console.log("JSON COUNT ",rawJson.length)
  return ([rawJson,phraseJson])
}

export function getCompleteWordlist() {
  return (completeWordlist.join(" "))
}
